import { market } from "../market/kr";
import { invite } from '../invite/kr';
import { property } from '../property/kr';
import {advertise} from '../advertise/kr';
import {login, download} from '../login/kr';
import {trading} from '../trading1/kr';
import { contest } from "../contest/kr";
import { merchandiser, common, tableList, dialog, codeInfo, hyy as contractHyy, placeOrder, codelist, panKou } from "../merchandiser/kr";
import { games } from '../games/kr';
import { taskCenter } from "../task/kr";
import { ieo } from "../ieo/kr";
import { earn } from "../earn/kr";
import { apis } from "../api/kr";
import { tradingContest } from "../tradingContest/kr";
import { agent } from "../agent/kr";
import { live } from "../live/kr";
import { hongbao } from "../hongbao/kr";
const time = {
  r: "일",
  s: "시",
  f: "분",
  m: "초"
};
// 状态
const state = {
  preheatIng: "준비 중",
  purchaseIng: "구매 중",
  over: "종료됨",
  finish: "완료됨",
  noData: "데이터 없음",
  process: "지원 중",
  sellout: "품절됨"
};
// 模板文字
const text = {
  now: "진행 중",
  start: "이 라운드 시작까지",
  end: "이 라운드 종료까지",
  jd: "이 라운드 진행률",
  complete: "완료됨",
  limited: "시간 제한 할인가",

  finish: "완료됨",
  subscribing: "신청 중",
  subscribeNow: "지금 신청",
  buyStart: "신청 시작까지 남은 시간",
  buyEnd: "신청 종료까지 남은 시간",
  projectAmount: "프로젝트 양",
  quota: "한도",
  buyPrice: "신청 가격",
  buyLimit: "신청 한도",
  buyAmount: "신청 양",
  buyPos: "신청 코인 보유",
  startDate: "시작 일시",
  endDate: "종료 일시",
  projectSuppot: "프로젝트 지원",
  websit: "프로젝트 웹사이트",
  projectDetail: "프로젝트 상세정보",
  cycle: "신청 주기",
  all: "모두",
  step1: "준비 중",
  step2: "신청 중",
  step3: "추첨 중",
  step4: "결과 발표",
  subOrder: "신청 주문",
  myOrder: "당첨 주문",
  proCoin: "프로젝트 코인",
  buyCoin: "신청 코인",
  orderDate: "주문 시간",
  issuanceQuota: "발행 한도",
  dealAmount: "거래 수량",
  dealPrice: "거래 금액",
  status: "상태",
  ctrl: "조작",
  checkOrder: "추첨 번호 확인",
  subNum: "신청 번호",
  myNum: "당첨 번호",
  status0: "신청 완료",
  status1: "대금 대기 중",
  status2: "완료됨",
  conditionTerm1: "신청 시작 시간 이전 *일까지,",
  conditionTerm2: "거래 쌍 *",
  conditionTerm3: "모든 거래 쌍",
  conditionTerm4: "코인-코인 거래의 총 금액 (USDT) 누적이 *에 도달할 때마다 1 양 신청 가능",
  noData: "데이터 없음",
  qgsc: "신청 잠금",
  yhsg: "추첨 신청",
  sgsb: "신청 실패",

  supply: "이 라운드 한도",
  rate: "환전 비율",
  ceiling: "도움 상한",
  xmwc: "프로젝트 완료됨",
  xmze: "프로젝트 총액",
  zkjj: "할인 평균가",
  cyrs: "참여자 수",
  round: "제 [] 라운드",
  r: "명",
  cgqg: "성공적인 신청",
  cgzl: "성공적인 도움",
  xmed: "프로젝트 양",
  kszl: "도움 시작 시간",
  ksqg: "신청 시작 시간",
  jsqg: "신청 종료 시간",
  jszl: "도움 종료 시간",
  hdgz: "이벤트 규정",
  xmjs: "프로젝트 소개",
  tcqr: "신청 취소 후 지불을 확인하면이 라운드 신청 기회를 잃을 수 있습니다. 신중히 조작하십시오!",
  jxtc: "계속 취소",
  fhzf: "결제로 돌아가기",
  qgrsd: "현재 신청 인원이 많아 노력 중입니다. 잠시 기다려주십시오!",
  zltcqr: "도움 취소 후 지불을 확인하면이 라운드 도움 기회를 잃을 수 있습니다. 신중히 조작하십시오!",
  zlqgrsd: "현재 도움 인원이 많아 잠시 기다려주십시오!",
  wxts: "안내 : 지불 확인을 빨리하십시오. []분 내에 지불이 완료되지 않으면 시간이 초과되어 창이 닫힙니다.",
};

const seckill = {
  sgno: "신청 조건이 충족되지 않았습니다",
  srjymm: "거래 비밀번호를 입력하세요",
  ljzf: "지금 지불",
  };
const apply = {
  condition: "신청 조건",
  apply: "지금 신청",
  buyPrice: "신청 가격",
  buyAmount: "신청 양",
  applyAmount: "신청 금액",
  forget: "거래 비밀번호를 잊으셨나요?",
  noAmount: "신청 양을 입력하세요",
  buyLimit: "신청 한도",
  success: "신청이 성공적으로 완료되었습니다!",
  paySummary:"안내 : 지불 확인을 빨리하십시오. <b>3분 내에</b> 지불이 완료되지 않으면 시간 초과로 창이 닫힙니다",
  appFull: "신청 양이 너무 많습니다",
  seckill_async_fail_13: "신청 간격은 {}분입니다",
};

const seckillRes = {
  seckill_async_3: "결제 중입니다. 잠시만 기다려주세요!",
  seckill_async_5: "취소 완료",
  seckill_async_fail_1: "죄송합니다! 페이지를 새로 고쳐 다시 시도하십시오!",
  seckill_async_fail_2: "죄송합니다! 페이지를 새로 고쳐 다시 시도하십시오!",
  seckill_async_fail_3: "죄송합니다! 페이지를 새로 고쳐 다시 시도하십시오!",
  seckill_async_fail_4: "죄송합니다! 할당량이 소진되었습니다!",
  seckill_async_fail_5: "죄송합니다! 결제 시간이 초과되었습니다. 다시 시도하십시오!",
  seckill_async_fail_6: "결제 비밀번호가 잘못되었습니다. 다시 입력하세요!",
  seckill_async_fail_7: "거래 비밀번호 오류 횟수가 초과되었습니다. 잠시 후 다시 시도하세요!",
  seckill_async_fail_8: "죄송합니다! 결제 시간이 초과되었습니다. 다시 시도하십시오!",
  seckill_async_fail_9: "죄송합니다! 할당량이 소진되었습니다. 다음에 성공하세요!",
  seckill_async_fail_10: "현재 많은 사람들이 구매 중입니다. 잠시 후 다시 시도하세요!",
  seckill_async_fail_11: "행위 검증 검증 실패!",
};
const header = {
  zcgl: "자산 관리",
  zczh: "자산 계정",
  bbzh: "코인 계정",
  fbzh: "매입 코인 계정",
  bdbzh: "코인 대출 보관함",
  wdgl: "위임 관리",
  lswt: "거래 내역",
  qbhz: "지갑 상호 전환",
  yhzx: "사용자 센터",
  wdhb: "내 쿠폰",
  openOrder: "현재 위임",
  dealStats: "거래 통계",
  totalAsset: "총 자산 가치",
  cz: "합의 계정",
  gmcnyt: "CNYT 구매",
  yqfy: "초대로",
  hbthhr: "HBT 파트너",
  tczh: "계정 종료",
  moreNew: "더 많은 공지",
  gfgg: "공식 공지",
  zxxw: "최신 뉴스",
  ckgd: "더 보기",
  bbdd: "코인 거래 주문",
  bbwhydd: "코인 표준 영구 계약 주문",
  etfdd: "ETF 주문",
  fbdd: "법정 거래 주문",
};

const recommend = {
  vol24h: "24시간 거래량",
  jyd: "거래 쌍",
  jydlx: "거래 쌍 유형",
  zxj: "최신 가격",
  change24: "24시간 변동",
  line24: "가격 추이 (3일)",
};

const hyy = {
  ty: "동의합니다",
  bkt: "미개시",
  wqdkt: "개시 확인",
  kt12: "1. 거래 도중에는 반드시 디지털 통화 계약 거래의 기본 지식과 관련 위험 및 파생상품 거래에 참여하는 모든 비즈니스 규칙을 자세히 이해해야합니다.",
  kt13: "2. 위험 경고서의 위험 사항은 예시에 불과하며 디지털 자산 파생 상품 거래의 모든 위험 요소를 상세히 나열하지 못했습니다. 디지털 자산 파생 상품 거래에 참여하기 전에 투자자는 기타 가능한 위험 요소에 대해 신중히 이해하고 파악해야합니다.",
  kt14: "3. 투자자는 위험을 감수하고 자신의 실제 상황, 예를 들어 위험 수용 능력 등을 고려하여 신중하게 이번 계약 거래에 참여할 것을 권고합니다.",
  kt0: "사용자님:",
  kt1: "계약 계정 및 계약 거래 권한을 아직 개시하지 않았습니다. 아래 내용을 자세히 읽은 후 개시 여부를 결정하십시오 :",
  kt2: "일, 계약 시장에서 거래하는 경우, 시장 가격 움직임이 귀하의 유리에 반대되어 귀하의 포지션 보증금이 부족 할 경우, BiKing 영구 계약은 시스템이 정의한대로 귀하의 포지션을 강제로 정리하고 강제 정리 세부 정보를 공개합니다.",
  kt3: "이 , 귀하는 BiKing 영구 계약의 비즈니스 규칙을 신중히 읽고 준수해야하며 계약 메커니즘 및 작동 원리, 시장의 여러 위험을 이해해야합니다.",
  kt4: "네, BiKing 영구 계약은 계약 거래 시스템에 연결됩니다. 사용자의 포지션 손익은 계약 시장의 움직임에 따라 변동되며 큰 손실이 발생 할 때 포지션이 시스템에서 강제 청산 될 수 있습니다. 사용자는 계약 시장 가격에 따라 즉시 자신의 거래 행동을 결정하고 수익과 손실을 스스로 부담해야합니다. 이로 인해 BiKing은 어떠한 가정이나 미리 정해진 보증책임도 부담하지 않습니다.",
  kt5: "다, 사용자가 플랫폼의 관련 규정을 자발적으로 준수하고 관련 국가 및 지역의 법률 및 규정을 자발적으로 준수해야합니다. 사용자의 계약 계정이 비정상적인 조작으로 인해 동결되면 사용자가 조작을 수행 할 수 없으며 플랫폼도 사용자를 위한 청산을 수행 할 수 없습니다. 참조하여 손실이나 청산을 발생시키지 않습니다.",
  kt6: "육, 디지털 자산 파생 상품 거래는 특정 국가 또는 지역의 정책 규제 리스크를 직면 할 수 있으며 거래 지역의 정책 규제 배경을 이해 한 후 판단을 내려야합니다. 관련 국가 및 지역의 법률, 규정, 정책의 변화, 계약 거래소 규칙의 수정, 긴급 조치 등의 이유로 BiKing은 미리 선언을 발표 할 것이며 보유중인 미 정리 계약이 계속 보유되지 못할 수 있지만 보증금 및 수익 잔액은 여전히 지불됩니다.",
  kt7: "칠, 비 플랫폼 측이 제어 할 수없는 이유로, 예를 들어 지진, 홍수, 화재 등의 불가항력 요소 또는 컴퓨터 시스템, 통신 시스템의 장애 등의 이유로 사용자의 지시가 거래되지 않거나 전체가 거래되지 않을 수 있습니다. 사용자가 직접 책임을 져야하는 손실이 발생할 수 있습니다.",
  kt8: "팔, “헤지”거래는 투기 거래와 마찬가지로 가격 변동으로 인한 위험을 안고 있습니다.",
  kta9: "구, 실명 인증을 완료하지 않았거나 구글 인증을 바인딩하지 않았거나 계정을 타인에게 빌려주면 계약 보증금의 안전성이 영향을 받을 수 있습니다.",
  kta10:"삼, 특정 시장 조건에서는 계약을 청산하기 어려울 수 있습니다. 예를 들어, 귀하의 수익이 전체 계약 시장의 유효한 레버리지 PnL에서 1위이고 상대방이 청산 손실을 지불 할 보증금이 충분하지 않은 경우.",
  kt9: "자세히 읽었으며 위험을 감수하겠습니다.",
  kt10: "계약 계정 및 계약 거래 권한을 개시",
  zjhz: "자금 이체",
  ljhz: "즉시 이체",
  qx: "이체 취소",
  khz: "이체 가능",
  qxz: "선택해주세요",
  bz: "코인",
  c: "출금",
  zz: "입금",
  sl: "수량",
  qb: "전부",
  ktcg: "개시 성공",
  ktsb: "개시 실패",
  hzcg: "이체 성공",
  hzsb: "이체 실패",
  wyyd: "", // 읽은 팁을 선택하지 않은 경우
  tc: "나가기",
  warning1: "코인을 선택하십시오",
  warning2: "출금 계정을 선택하십시오",
  warning3: "입금 계정을 선택하십시오",
  warning4: "최대 전환 가능한 양 이상을 입력하십시오",
  warning5: "소수점 4자리까지 입력 가능합니다",
  gb: "닫기",
  openSuccess: "계약 거래가 개시되었습니다.",
  openSuccessTip: "자금을 계약 계정으로 이체하세요",
  wsmyz: "실명 인증을 완료하지 않았습니다",
  hdnm: "실명 인증을 완료하고 누적 순 이체 [*]USDT당 [**]USDT 를받을 수 있습니다.",
  nmjl: "모래 기록",
  nmhzjl: "모래 녹음기록",
  gxn: "축하합니다!",
  qwjy: "거래로 이동",
  yfrndhyzh: "계약 계정으로 입력되었습니다.",
  nzxy: "계약 계정으로 이체하십시오 [*]USDT 및 [**]USDT 를받을 수 있습니다.",
  nmssm: "모래 무엇입니까",
  nm: "모래",
  nxhyzh: "당신은 계약 계정으로 이체합니다.",
  text1: "계약 계정으로 누적 순 이체 [*]USDT 이상을받습니다.",
  text2: "계약 계정으로 이체하면 [*]USDT를받을 수 있습니다.",
  text3: "모래",
  text4: "잔액",
  text5: "계약 계정으로 누적 순 이체 [*]USDT이상을받았습니다.",
  not_get_nm: "죄송합니다. 모래 이벤트가 종료되었습니다. 이번 이체에서 모래를받을 수 없습니다.",
  yijie: "1 차",
  erjie: "2 차",
  ljjhr: "누적 순 이체",
  khd: "수령 가능",
  hysnm: "계약으로 모래 선물",
  bbgg: "영구 계약 100 배 레버리지",
  hdsj: "활동 시간 :",
  hdxq: "활동 상세 정보",
  ljhd: "즉시 수령",
  xdxd: "선착순",
  ylnnz: "이기면 가져 가고 지면 내 것입니다.",
};

const Verification = {
  channel: "공식 인증 채널",
  verify: "인증할 정보를 입력하세요",
  notes: "안전 안내",
  notes1:"1. BiKing과 관련된 모든 이메일, 위챗 ID, QQ ID, 도메인 및 미디어 ID는 여기에서 인증할 수 있습니다.",
  notes2: "2. 소셜 미디어 계정(웨이보, 트위터 등)은 대소문자를 구분하여 이름으로만 검색됩니다.",
  notes3: "3. 인증 결과에 의문이 있는 경우, 공식 고객 서비스에 문의하여 다시 확인할 수 있습니다.",
  error: "인증 실패",
  error1: "귀하가 조회한 정보",
  error2: "는 공식 인증 채널이 아닙니다. 자산 안전을 유의하시고 개인 정보 누출을 방지하십시오.",
  errorNote: "주의 사항",
  errorNote1:"1. 현재 공식 인증 채널은 이메일, 공식 위챗 ID, QQ ID, 도메인 및 소셜 미디어 계정 인증만 지원합니다.",
  errorNote2: "2. 위챗 등 메신저 도구는 계정(닉네임이 아님)으로만 검색됩니다.",
  errorNote3: "3. 소셜 미디어 계정은 이름으로만 검색되며 대소문자를 구분합니다.",
  success: "인증 성공",
  success1: "귀하가 조회한 정보:",
  success2: "은(는) BiKing 공식으로 인증되었습니다.",
  success3: "만약 해당 번호/계정이 다른 채널에 나타나면 신뢰할 수 없으니 자산 안전에 유의하십시오.",
  more: "더 보기",
  know: "알겠습니다",
  weChat: "위챗",
  name: "도메인",
  webo: "웨이보",
  twitter: "트위터",
  email: "이메일",
  contact: "고객 서비스에 연락하기",
  bannerTip:"불법자들이 BiKing 명의를 사용하여 사기를 시도하는 것을 방지하기 위해 여기에서 귀하의 전화, 위챗 등이 BiKing 공식 채널인지 확인할 수 있습니다.",
};
const index = {
  downloadIos: 'AppStore 다운로드',
  downloadAndroid: '안드로이드 다운로드',
  downloadGoogle: 'Google Play 다운로드'
};

const indexPage = {
  gfgg: "공식 공지",
  zxxw: "최신 뉴스",
  ckgd: "더 보기",
};

const NAVS = {
  hqsj: '마켓',
  game: '게임',
  fx: '발견',
  sj: '데이터',
  fb: "매수",
  jr: "재정",
  ty: '체육',
  fb: "피아트 거래",
  bb: "현물 거래",
  jyds: "거래 대회",
  hbhd: "레드 패킷 이벤트",
  gg: "레버리지 거래",
  yxhy: "퍼텐셜 계약",
  eft: "ETF 거래",
  flhd: "혜택 이벤트",
  flzx: "혜택",
  fast: "빠른 거래",
  spec: "전문 거래",
  login: "로그인",
  rig: "등록",
  downapp: "BiKing 앱 다운로드",
  downappsum: "원활한 체험, 초고속 입출금",
  zichan: "자산",
  order: "주문",
  qbhz: "지갑 상호 변환",
  lang: "언어",
  calc: "평가",

  mb: "매수",
  hq: "시장",
  hy: "계약",
  jy: "거래",
  lc: "채굴",
  fs: "Fansup",
  xy: "아카데미",
  byxy: "BiKing 아카데미",
  byyx: "BiKing 연수",
  coins: "COINS 포인트",
  gd: "더 보기",
  yqhy: "친구 초대",
  rwzx: "임무 센터",
  bbms: "USDT로 비트코인 및 기타 디지털 자산 구매",
  ggms: "플랫폼에 자산을 대출하여 수익과 위험을 증폭시킵니다",
  yxms: "백배 레버리지 지원, 조작이 편리하고 다양합니다",
  etfms: "수익을 증폭시키고 폭락 위험을 없앱니다",
  pool: "공유 광산",
  czzn: '이용가이드',
  gywm: '회사 소개',
  zhxx: '계정 정보',
  gd:"복사 계약",
  yxhy: "퍼텐셜 계약",
  zjhy: "보너스 계약",
  product: "제품",
};

const FOOTERS = {
  zxkf: "온라인 고객 서비스",
  fawu: "법률 조언",

  us: "우리",
  product: "제품",
  service: "서비스",
  college: "학습",

  aboutUs: "회사 소개",
  rateSum: "수수료 설명",
  notices: "공지 사항",
  helps: "도움말 센터",
  verific: "공식 인증 채널",
  contact: "문의하기",

  fabi: "매수",
  bibi: "비트코인 거래",
  ganggan: "레버리지 거래",
  swiper: "퍼텐셜 계약",
  etf: "ETF 거래",
  licai: "채굴",

  apis: "API 지원",
  apisNew: "API 지원",
  addCoin: "상장 신청",
  vips: "VIP 혜택",
  downapp: "앱 다운로드",
  files: "법적 문서",

  newuser: "BiKing 신입 회원 학습",
  swiperSchool: "계약 아카데미",
  assistant: "학습 도우미",
  digitalintroduction: "디지털 자산 소개",

  watchword: "글로벌 급 녹색 거래 플랫폼",
  meiyitian: "매일, 부의 변화를 경험하십시오",
  chat: "채팅 방",
  shequncn: "텔레그램 중국어 커뮤니티",
  shequnen: "텔레그램 영어 커뮤니티",
  shequnkr: "텔레그램 한국어 커뮤니티",
};

const SIDEBAR = {
  newuser: "초보자",
  guide: "가이드",
  bbsq: "비트코인 커뮤니티",
  hysq: "계약 커뮤니티",
  gd: "고정",
  sq: "접기",
};

const banner = {
  wzwh: 'BiKing 웹 사이트 및/또는 계정 유지는 당사가 업데이트한',
  sytk: '이용 약관',
  yszc: '개인 정보 정책',
  hh: '및',
  cookie: '쿠키 정책',
  djgb: '을 사용함을 의미합니다. “X”를 클릭하여 위 약관 및 정책을 읽고 동의합니다.',

  title: '다양한 게임및 가상자산 거래 플랫폼',
  marketTitle: '가상자산거래, 우리는 프로패셔널합니다',
  marketSubTitle: '이용자에게 보다  안전하고 안정적인 가상자산 파생상품거래 서비스를제공하기위해  노력하고  있습니다',
  pathTitle: '가상자산거래의 여정을 위한  믿을수 있는 파트너',
  pathSubTitle: '수백만명의 이용자가 선택한  신뢰할수 있는 파트너',
  jylz: '3,000 억 미국 달러',
  jyl: '72시간 거래량',
  sxs: '암호화폐가 온라인',
  zcyh: '등록 사용자',
  zdjy: '최저 거래 수수료',
  connectTitle: 'Biking 거래소를 선택해야 하는 이유',
  connectSubTitle: 'Biking거래소는 보다높은 가치를 창출하고 자산을 보호하는데  도움을드립니다',
  advantageText1: '최고의 성능 · 초고속 거래',
  advantageSubText1: '런던 증권거래소 기술을 기반으로한  최고의 성능과 초고속 스피드,초저지연,  빠른 매칭을 지원합니다',
  advantageText2: '유저의 자산보호 · 극한의 안정성',
  advantageSubText2: 'Biking는 자산및  데이터의 안전을 보장하기위해 CCSS표준을 준수합니다',
  advantageText3: '높은 유동성·낮은 스프레드',
  advantageSubText3: 'Biking 컨트랙트 레버리지 거래, 초고효율, 미니멈 슬리피지',
  advantageText4: '24시간 연중무휴 서비스',
  advantageSubText4: '시스템이 정상 작동하는지 체크하고 24시간 연중무휴 고객서비스를 제공합니다',
  advantageText5: '사용편의성 제공',
  advantageSubText5: '유저에게 사용편의성을 제공하고 다양한 오더 시스템과 트래이딩 툴을 제공하여 리스크를 관리합니다',
  advantageText6: '언제 어디서나 · 안전한 거래',
  advantageSubText6: 'Biking 플랫폼은 언제 어디서나 안심하고  거래할 수 있으며  웹버전, 모바일 앱, API 및 FIX 연결을 제공합니다',
  netWorkTitle: '26개국 120만 명 이상의 사용자가 선택한 플랫폼',
  netWorkSubTitle: '이용자에게 보다  안전하고 안정적인 가상자산 파생상품거래 서비스를제공하기위해  노력하고  있습니다',
  smxz: 'QR 코드를 스캔하여 다운로드',
  fxbzj: '위험 보증금',
  fkbz: '모든 거래에 완전한 자금 위험 관리 보호를 제공합니다',
  question1: '1. BiKing 거래소 소개',
  questionContent1: 'BiKing 거래소는 미국/캐나다 MSB 이중 라이센스를 보유한 글로벌 선도적인 싱가포르 디지털 자산 거래 플랫폼으로, 다양한 디지털 자산의 거래, 보관, 관리 등의 서비스를 제공합니다.',
  question2: '2. BiKing 거래소는 어떤 제품을 제공하나요?',
  questionContent2: 'BiKing 거래소는 다음과 같은 제품을 제공합니다: 퍼텐셜 계약 - 우수한 깊이, 초고속 일치; 현물 거래 - 0 수수료, 빠른 체결; 거래 커뮤니티 - 숙련된 트레이더, 안정적인 전략; 증권 거래 - 독특한 모델, 지속적인 혜택; 웹 지갑 - 탈중앙화 통합 서비스',
  question3: '3. BiKing 거래소에 어떻게 등록하나요?',
  questionContent3: 'BiKing 거래소 공식 웹 사이트 또는 BiKing 앱에서 등록할 수 있습니다. 등록을 클릭하고 등록 프로세스를 완료하면 BiKing 거래소를 사용하여 디지털 화폐 투자 및 금융을 시작할 수 있습니다.',
  question4: '4. BiKing 거래소에서 디지털 화폐를 어떻게 구매하나요?',
  questionContent4: 'BiKing 거래소는 다양한 결제 방법과 다양한 법정화폐를 지원하여 글로벌 사용자들에게 더 많은 선택과 편의를 제공합니다. 어떤 국가나 지역에서도 사용자는 지역 통화를 사용하여 디지털 화폐를 손쉽게 구매할 수 있습니다.',
  question5: '5. 디지털 자산 거래를 어떻게 진행하나요?',
  questionContent5: 'BiKing 거래소에서 거래하려는 디지털 자산을 선택하고 거래 페이지로 이동한 후 구매 또는 판매를 선택하여 거래 수량과 가격을 입력하고 거래를 확인할 수 있습니다. 또한 BiKing 거래소는 비트코인, 이더리움, 라이트코인, 리플 등 다양한 디지털 자산 거래를 지원합니다.',
  question6: '6. BiKing 거래소는 사용자 자산 안전을 어떻게 보장하나요?',
  questionContent6: 'BiKing 거래소는 다층 암호화 기술을 사용하여 사용자 정보 및 자산을 안전하게 보호하고 있으며, 콜드 월렛과 핫 월렛을 분리하여 저장하여 사용자 자산의 안전을 보장합니다.',

  investor: '300만 명의 암호화폐 투자자들의 신뢰',
  transaction: 'BiKing에서 투자, 거래 및 성장',
  hypt: '글로벌 안전 선도적인 디지털 자산 계약 거래 플랫폼',
  yjpc: '한 번 클릭으로 포지션 열기/닫기',
  jscrj: '빠른 입출금. 60초안에 거래시작, 제로 슬라이딩 포인트거래 실현',
  zcpt: '등록하고 USDT 받기',
  email: '이메일 주소',
  phone: '전화 번호',
  zc: '등록',
  yhjaqbz: '은행수준의 보안을 실현하였습니다',
  lhdmch: '제로 슬리피지 세컨드매칭',
  qthkf: '7*24시간 고객 서비스',
  rmjmhb: '인기있는 암호화폐',
  jrsq: 'BiKing 커뮤니티 가입하기',
  hqzxhd: '최신 BiKing 활동 정보 및 온라인 지원 받기',
}
const navCard = {
  join: 'BiKing에 가입하기',
  hzdl: 'BiKing 코인 왕 협력 대리인 계약을 기다리고 있습니다.',
  jmrx: '대리 가입 핫라인: 183283232998',
  contract: '온라인 계약',
  yxhy: '빠른 계약 코인 왕 이중 계약 깜짝 출시',
  jylh: '거래 더 유연하고 수익 더 풍부',
  usa: '미국 및 캐나다 MSB',
  zmjys: '해외 유명 거래소 BiKing 코인 왕 다국적 규정 준수 촬영',
  fxpf: '위험은 즉시 보상되며 안전하고 신뢰할 수 있습니다.',
  srhy: '코인 왕 첫 계약에 30%의 진금을 제공합니다.',
  hdsj: '이벤트 기간: 2022년 11월 1일 0시부터 2022년 12월 1일 0시까지'
}

const choice = {
  gjyh: '26개국 120만 명의 공동 선택',
  jyfu: '사용자에게 더 안전하고 안정적인 암호화 자산 파생 상품 거래 서비스를 제공하기 위해 노력하고 있습니다.',
  wsmxzwm: '왜 우리를 선택해야합니까?',
  jsty: '초고속 스피드 체험',
  jmsj: '거래 인터페이스 디자인은 플랫폼의 몇 년간의 사용자 운영 경험을 결합하여 명확한 프로세스, 편리한 조작 및 마이크로초 수준의 코어 메모리 매칭 기술을 제공하여 사용자에게 더 편리하고 편안한 거래 경험을 제공합니다.',
  kfx: '위험 대응 가격 메커니즘',
  pthybz: '플랫폼 계약 코인의 가격은 다중 소스 지수 통합 알고리즘을 사용하여 강력한 위험 제어 능력을 갖추어 다양한 극단적인 시장 상황에서 발생할 수 있는 사용자 위험과 손실을 효과적으로 회피합니다.',
  zjaqbz: '자금 안전 보장',
  zjdt: '모든 자금 이동은 다중 오프라인 서명으로 완료되어 마이크로 초급 판단을 보장하고 심층적인 냉동 보관 자산을 보유하여 모든 사용자의 자금 안전을 보호하고 모든 사용자에게 100% 의 은행 수준의 보안 리스크를 제공합니다.',
  jszc: '최상레벨의 기술서포트',
  ptjstd: '플랫폼 기술 팀은 최고 수준의 블록 체인 기술 전문가들로 구성되어 사용자의 극한 경험을 보장하고 플랫폼의 개발과 운영을 강력하게 지원합니다.',
  jcjz: '계단식 감소 기구',
  hqbh: '시장 상황 변화에 따라 합리적으로 사용자 거래 리스크 제어 메커니즘을 트리거하고 사용자의 자산을 24 시간 동안 안전하게 보호합니다.',
  kf: '24시간 고객 서비스',
  ptkf: '플랫폼은 24시간 고객 서비스 순환 체제를 채택하여 사용자가 겪는 모든 문제를 진지하게 대합니다.'
}

const plat = {
  ptgn: '플랫폼 기능',
  zjms: '보너스 모드',
  zjjs: '보너스 모드는 코인 왕 팀이 전체 네트워크 계약 사용자를 위해 첫 번째로 시작한 특색있는 계약 새로운 플레이입니다. 보너스 모드의 작업 흐름은 실거래 계약과 동일하며, 개장시에 획득한 수익 부분은 계약 계정으로 이체되어 계속 개장하거나 직접 출금에 사용됩니다. 획득 방법에는 수수료 실시간 환급, 이벤트 공기업, 작업 완료 등이 포함됩니다.',
  zcms: '풀 포지션 모드',
  zcjs: '풀 포지션 모드에서 모든 포지션의 보증금 및 플로팅 손익이 상호 연결되며, 개장 보증금을 포함한 모든 계정 자산이 플로팅 보증금으로 취급됩니다. 풀 포지션 모드는 강력한 리스크 컨트롤 능력을 갖추고 있지만, 동시에 시장 변동이 심할 경우 손실 예상을 초과하기 쉽습니다.',
  zucms: '단일 포지션 모드',
  zucjs: '단일 포지션 모드에서 각 주문은 서로 독립적으로 처리되며, 각 포지션의 개장 가격에 따라 수익과 손실이 독립적으로 계산됩니다. 단일 주문의 기본 금액 (또는 보증금이라고도 함)이 최대 손실 포인트에 도달하면 강제로 청산됩니다. 최대 이익 포인트에 도달하면 자동으로 청산됩니다. 단일 포지션 모드에서 포지션 또는 계획 주문이있는 경우 단일 포지션 모드 개장으로 전환할 수 없습니다.',
  gdgn: '팔로우 기능',
  gdjs: '팔로우 기능을 활성화하면 팔로우 트레이더의 모든 개장 및 청산 작업이 동기화됩니다. 계정 잔액이 부족하거나 포지션 한도를 초과하는 경우에만 동기화를 완료할 수 없습니다. 수동으로 팔로우 기능을 취소하지 않으면 팔로우 기능이 계속 활성화됩니다.',
  bfpc: '부분 청산',
  bfjs: '일정 수량의 롱 포지션 또는 숏 포지션을 보유한 경우, 시장 변동 및 수익과 손실 상황에 따라 자유롭게 청산 금액을 선택할 수 있습니다. 동시에 포지션의 손익 금액은 청산 금액 및 전체 보증금 비율에 따라 손익이 동등하게 결제됩니다. 청산 후에 플로팅 이익이 변하지 않습니다.',
  fxkc: '반대 개장',
  fxjs: '시스템은 시장 최적가격을 사용하여 현재 선택한 보유 포지션을 자동으로 청산하고 시장 최적가격을 사용하여 반대 방향과 동일한 보유 포지션 수량을 개장하여 역전 시장을 놓치거나 역전 시장이 올 때 개장을 놓치지 않습니다.',
  zjbzj: '추가 보증금',
  zjbzjjs: '일정 수량의 롱 포지션 또는 숏 포지션을 보유한 경우, 현재 보유중인 모든 매개 변수에 추가 보증금을 추가 할 수 있습니다. 보증금을 추가 한 후 포지션 계수는 개장 및 보증금 추가시의 각 포지션 매개 변수에 따라 가중 분배 공식으로 계산됩니다.'
}

const risk = {
  fxbzj: '리스크 보증금',
  fxbz: '모든 거래에 대해 전방위 자금 리스크 보호를 제공합니다.'
}

const license = {
  license: '코인 왕은 MSB 금융 라이선스를 획득했습니다.',
  hgyy: '합법적 운영, 전 세계적인 배치',
  login: '로그인',
  download: '코인 왕 다운로드를 스캔하십시오.',
  support: '지원',
  jsjy: '언제 어디서나 빠른 거래',
  ljxz: '지금 바로 BiKing 앱을 다운로드하세요.'
}

const footer = {
  yhyh: '사용자 친화적',
  jypt: '계약 거래 플랫폼',
  yhzc: '사용자 지원',
  flsm: '요금 설명',
  ggzx: '공지 센터',
  yhxz: '사용자 안내',
  tksm: '약관 설명',
  fxzs: '리스크 경고',
  xylb: '계약 목록',
  gywm: '우리에 관하여',
  gy: '약',
  lxwm: '문의하기',
  appxz: '앱 다운로드',
  callus: 'BIKING 창시자 구독',
  zwzxxx: '최신 뉴스, 인사이트 및 가격 변동을 파악하십시오.',
  zc: '가입',
  email: '이메일 주소',
  callingus: '문의하기',
  bqsy: '판권 소유',
  tips: '투자는 리스크를 동반하며 시장 진입은 신중하게 고려해야 합니다.'
}

const card = {
  title: '왜 우리는 가장 친절한 계약 플랫폼인가요?',
  text: 'BiKing이 자산을 창출, 증가 및 안전하게 보호하도록 도와드립니다.',
  djxn: '수수료 환급',
  jsqd: '수수료 100% 실시간 환급으로 거래 비용을 크게 낮추고 수익 기회를 높입니다.',
  zcbz: '최고의 입출금 속도',
  cssbz: '최고의 입출금 속도, 카드없이 부드럽게 입금 및 출금하여 사용자 자금의 안전을 보장하고 거래 기회를 놓치지 않습니다.',
  gld: '편리하고 사용하기 쉽습니다.',
  zxhd: '가입 및 개장은 10초 만에 완료되며 독특한 안전 리스크 컨트롤 시스템으로 사용자의 프라이버시를 보호합니다. 등록 절차가 더욱 간단해집니다.',
  qthfw: '24시간 서비스',
  kffw: '편안하고 부드러운 상호 작용 경험, 금전적 보증금 시스템, 24시간 온라인 고객 서비스, 거래 문제에 대한 실시간 답변',
  bjyy: '편리하고 사용하기 쉽습니다.',
  fxkk: '다양한 주문 시스템 및 거래 도구를 제공하여 리스크를 관리 할 수 있습니다.',
  axjy: '언제 어디서나 안전한 거래',
  bkms: 'BiKing 플랫폼은 웹 버전, 모바일 애플리케이션, API 및 FIX 연결을 제공합니다.'
}

const news = {
  title: '뉴스 & 인사이트',
  text: '세계 최고의 암호화폐 거래소의 뉴스 및 비즈니스 특징을 알아보세요.',
  sy: '인사이트',
  ltitle: '비트코인이 신흥 시장의 독특한 도전을 해결할 수 있습니까?',
  ldesc: '이 기사는 처음에 코인 텔레그래프와 동등합니다. 블록체인 경제 이스탄불 정상 회의가 신흥 시장의 발전에 초점을 맞추면서 비트코인의 보급이 계속해서 사례 요구에 의해 주도되고 있습니까? …',
  more: '자세히 알아보기',
  xwfbs1: '뉴스 룸',
  rdesc1: '디지털 자산 거래소 BiKng이 2022년 블록체인 경제 이스탄불 정상 회의를 후원합니다.',
  xwfbs2: '뉴스 룸',
  rdesc2: '디지털 자산 거래소 BiKng이 2022년 블록체인 경제 이스탄불 정상 회의를 후원합니다.',
}

const info = {
  hzhb: '자동화 된 거래 플랫폼 파트너',
  qsjy: 'BiKing에서 거래 로봇 사용하기 쉽게',
  quadency: 'QUADENCY',
  clpt: '전문적인 자동 거래 전략 플랫폼',
  stacked: 'Stacked',
  glcf: '사용자는 Stacked를 사용하여 암호화폐 지수에 투자 할 수 있습니다. 자동 거래 및 자산 관리'
}
const menu = {
  creditCardOrder: '주문 결제',
  ptmb: 'C2C',
  kjmb: '빠른 구매',
  xykmb: '신용카드로 구매',
  order: '주문',
  userOrder: '사용자 주문',
  merchantOrder: '상인 주문',
  quickOrder: '빠른 주문',
  merchant:'상인',
  asMerchant:'상인으로서',
  advertisingManage: '광고 관리',
  financialStatements: '재무 보고서',
  messageCenter: '메시지 센터',
  more: '더보기',
  paymentSettings: '결제 설정',
  publish: '광고 게시',
  overview: '개요',
  aqzx: '보안 센터',
  phsz: '환경 설정',
  hykhj: '계약 카니발 계약 새 시대',
  xszn: '입문서',
  bwyjy: '코인 왕 연구소',
  bwsq: '코인 왕 커뮤니티',
  yhxz: '사용자 안내',
  bwysp: '코인 왕 파생 상품',
  jyxz: 'OTC 거래 주의사항'
}
const otc = {
  Realtimequotes:'실시간 시세는 참고용입니다. 타사 서비스 제공업체 웹사이트의 가격을 참조하십시오.',
  Realtimequotes1:'거래 한도',
  Realtimequotes2:'참고 가격  （{price}）',
  Realtimequotes3:'구매',
  Realtimequotes5:'구매 금액을 입력하세요.',
  Realtimequotes6:'최대',
  Realtimequotes7:'최대 한도 초과',
  Realtimequotes8:'수량',
  Realtimequotes9:'처리 수수료',
  Realtimequotes10:'결제 방법',
  Realtimequotes11:'배송 시간',
  Realtimequotes12:'결제 완료 후 10-20분',
  Realtimequotes13:'구매 확인',
  Realtimequotes14:'구매 단계',
  Realtimequotes15:'구매할 디지털 화폐, 지불할 법정 화폐, 서비스 제공업체를 선택하세요.',
  Realtimequotes16:'구매 금액을 입력하고 타사 서비스 제공업체 웹사이트의 정보를 입력한 후 결제를 완료하세요.',
  Realtimequotes17:'구매한 디지털 화폐는 BiKing 자산 충전 내역과 서비스 제공업체 웹사이트의 주문 내역에서 확인할 수 있습니다.',
  Realtimequotes18:'구매를 위해 {XXXXX} 페이지로 리디렉션됩니다.',
  Realtimequotes24:'알림',
  Realtimequotes19:'{XXXXX}는 독립적으로 운영되는 제3자 법정화폐 및 암호화폐 거래 플랫폼입니다. 모든 관련 서비스는 {XXXXX}에서 제공합니다.;',
  Realtimequotes20:'참고 가격에는 플랫폼 수수료가 포함되어 있습니다. 실제 거래 가격은 {XXXXX} 공식 웹사이트 가격을 기준으로 합니다.;',
  Realtimequotes21:'BiKing은 이 서비스 이용으로 인해 발생하는 모든 손실이나 손해에 대해 책임을 지지 않습니다.',
  Realtimequotes22:'확인했습니다. 지금 진행하세요.',
    Realtimequotes23:'금액을 입력하세요',
  Realtimequotes25:'제3자 거래',
  Realtimequotes26:'먼저 이메일 주소를 입력해 주세요',
    Realtimequotes27:'지금 완료',
     Realtimequotes28:'제3자 가맹점명',
  meBuy: '구매하고 싶습니다',
    服务商: '서비스 제공업체',
  bjgq: "이 견적은 만료되었습니다. 다시 가져와 주세요.",
  gxbj: "견적 업데이트",
  zxkdh: '최소 교환 가능 {min} {symbol}',
  zdkdh: '최대 교환 가능 {max} {symbol}',
  Available: '사용 가능한 잔액',
  Unknown: '미지',
  qxgz: '취소 규칙: 구매자가 당일 200건 이상 취소할 경우 당일 구매 기능이 제한됩니다.',
  xncs: '판매자에게 판매',
  qxzzffs: '결제 방법을 선택하세요',
  qdqx: '취소 확인',
  wzxx: '다시 생각해보기',
  msk: '구매자 결제 방법',
  zhmc: '계정 이름',
  zhxq: '계정 세부 정보',
  xzhb: '화폐 선택',
  
  buyer: '구매자',
  seller: '판매자',
  goSet: '추가하러 가기',
  addPayWayTitle: '결제 방법 추가',
  addPayWay: '최소 하나 이상의 결제 방법을 추가하거나 활성화해야 {type} 암호화폐를 거래할 수 있습니다.',
  supportPayWay: '{type}를 지원하는 결제 방법을 추가하고 활성화해야 합니다.',
  top: '상단 고정',
  marginTips: '당신은 이미 {baseMarginPaid} USDT의 보증금을 지불했으며 {needMargin} USDT보다 적어도 추가 지불해야 합니다.',
  eyqx: '매일 3회 이상 취소 신청 시 취소 권한이 제한되며, 악의적인 취소가 확인되면 계정이 차단될 수 있으므로 신중하게 조치하십시오!',
  qdbzgm: '구매를 그만두시겠습니까?',
  qxbtk: '주문을 취소하면 환불되지 않으며, 이미 결제했다면 주문을 취소하지 마십시오.',
  yzjbzj: '일반 상인이 추가 보증금을 지불했습니다',
  xbjjcbzj: '기본 보증금을 추가로 지불해야 합니다',
  jg: '가격',
  zxjgxd: '현재 최신 가격으로 주문',
  je: '금액',

  ccxe: '한도 초과',
  yebz: '잔액 부족',
  qxsm: '우선 본인 인증을 하십시오',

  dfb: '지급 대기',
  jywc: '거래 완료',
  buy: '구매',
  sell: '판매',
  coin: '코인',
  allCoin: '모든 코인',
  frenchCurrency: '법정 통화',
  payWay: '결제 방법',
  all: '전체',
  bankCard: '은행 카드',
  zfb: '알리페이',
  wx: '위챗',
  search: '검색',
  merchant: '상인 (30일 거래 완료/30일 완료율)',
  turnover: '거래량',
  completionRate: '% 완료율',
  quotaOrNumber:'수량/한도',
  number: '수량',
  quota: '한도',
  price: '가격',
  paymentMethod: '결제 방식',
  trade: '거래',
  handlingFee: '수수료 없음',
  buyUsdt: 'USDT 구매',
  sellBtc: 'USDT 판매',
  theRemainingAmount: '잔여 수량',
  userRealName: '사용자 실명',
  businessMessage: '상인 메시지',
  wantPay: '결제하고 싶어요',
  wantSell: '판매하고 싶어요',
  receive: '수령 예정',
  password: '비밀번호',
  pleaseEnterPassword: '비밀번호를 입력하세요',
  cancel: '취소',
  buyUSDT: 'USDT 구매',
  sellUSDT: 'USDT 판매',
  Paymentchannel :'결제채널 (서비스 제공자의 환율을 참고하세요.)',
  lumpSum: '총액',
  agree: '코인킹과 C2C 거래에 동의하면 코인킹의 C2C 거래 면책 조항에 동의하는 것입니다.',
  mzsm: '코인킹 C2C 거래 법률 면책 성명',
  quit: '나가기',
  confirm: '확인',
  orderDetail: '주문 상세 정보',
  limitExceeded: '한도 초과',
  quantityRemaining: '남은 수량이 충분하지 않습니다.',

  cryptoTitle: '몇 단계만으로 쉽게 USDT를 구매하세요',
  cryptoSubTitle: '글로벌 안전 선도적인 디지털 자산 계약 거래 플랫폼',
  availableBalance: '가용 잔액',
  sellAll: '전부 판매',
  fundsTransfer: '자금 이체',
  threeStep: '코인 구매는 단 세 단계만',
  advantage: '코인왕 거래소를 선택하는 이유',
  commonQuestion: '일반적인 질문',
  otc_title: 'C2C로 암호화폐 구매/판매 시 0 수수료',
  otc_title1: 'BiKing에서 안전하고 쉽게 0 수수료 거래하세요. 은행 송금, 신용카드 등 다양한 결제 수단으로 USDT 거래를 즉시 시작하세요.',
  commonQuestion1: 'C2C 거래란 무엇인가요?',
  commonQuestion2: 'C2C 거래 수수료는 얼마인가요?',
  commonQuestion3: '코인왕 C2C 상인이란 무엇인가요?',
  commonQuestion4: '코인왕 C2C 상인은 이윤을 낼까요?',
  commonQuestion5: 'C2C 사기를 피하는 방법은 무엇인가요?',
  commonQuestion1_desc: 'C2C는 개인 간 암호화폐 거래를 의미하며 중개없이 암호화폐를 직접 거래할 수 있습니다.',
  commonQuestion2_desc: 'C2C 거래 수수료는 플랫폼, 특정 암호화폐 및 거래 시 네트워크 혼잡도에 따라 크게 다를 수 있습니다. 그러나 코인왕 C2C는 암호화폐 거래에 대해 수수료를 청구하지 않습니다.',
  commonQuestion3_desc: '코인왕 C2C 상인은 인증된 사용자로, 거래 광고를 게시하고 다른 사용자와 거래할 수 있습니다.',
  commonQuestion4_desc: '코인왕 C2C 상인의 수익은 상인의 거래 전략, 거래 빈도, 매매 스프레드 및 전체 시장 상황 등 여러 요소에 따라 다릅니다.',
  commonQuestion5_desc: 'C2C 사기를 예방하기 위해 상대방의 신원을 확인하고 안전한 플랫폼을 사용하고 개인 또는 재무 데이터 공유를 제한하며 추적 가능한 결제 방법을 사용하세요.',
  register: '등록',
  registerByPhone: '이메일 또는 휴대폰 번호로 등록',
  authentication: '신원 확인',
  authenticationId: 'ID 신분증으로 신원 확인 완료',
  buyCoins: '코인 구매',
  buyCoinsByCard: '신용카드/직불카드 또는 은행 송금으로 코인 구매',
  fast: '빠르고 편리한',
  easyUse: '코인 구매 과정이 간단합니다',
  fastPayment: '몇 분 만에 빠른 입금이 가능합니다.',
  multiplePayment: '다양한 결제 수단',
  platformSupports: '플랫폼은 다양한 결제 수단을 지원합니다',
  flexibleConvenient: '사용자에게 더 큰 유연성과 편의성을 제공합니다.',
  safeReliable: '안전하고 신뢰할 수 있음',
  measure: '다중 보안 기술과 조치를 채택하였습니다',
  informationSecurity: '자금 및 사용자 정보의 안전을 보장합니다.',
  questionTitle1: '1. 코인왕 거래소 소개',
  questionSubTitle1: '코인왕 거래소는 싱가포르의 선도적인 디지털 자산 거래 플랫폼으로, 미국/캐나다 MSB 이중 라이선스를 보유하고 있으며 다양한 디지털 자산 거래, 보관, 관리 등의 서비스를 제공합니다.',
  questionTitle2: '2. 코인왕 거래소가 제공하는 제품은 무엇인가요?',
  questionSubTitle2: '코인왕 거래소는 다음과 같은 제품을 제공합니다: 퍼펫 컨트랙트 - 우수한 깊이, 초고속 일치; 현물 거래 - 0 수수료, 빠른 체결; 따라하기 커뮤니티 - 숙련된 트레이더, 안정된 전략; 기부 거래 - 독특한 모델, 지속적인 혜택; Web 지갑 - 탈중앙화된 통합 서비스',
  questionTitle3: '3. 코인왕 거래소에 어떻게 등록하나요?',
  questionSubTitle3: '코인왕 거래소 공식 웹 사이트 또는 코인왕 앱에서 등록할 수 있습니다. 등록을 클릭하고 등록 프로세스를 완료하면 코인왕 거래소를 사용하여 디지털 자산 투자 및 자금 운용을 시작할 수 있습니다.',
  questionTitle4: '4. 코인왕 거래소를 통해 디지털 자산을 어떻게 구매하나요?',
  questionSubTitle4: '코인왕 거래소의 빠른 코인 구매는 다양한 결제 수단과 다양한 법정화폐를 지원하며 전 세계 사용자에게 더 많은 선택과 편의를 제공합니다. 사용자가 어느 국가나 지역에서 와도 현지 화폐로 디지털 자산을 쉽게 구매할 수 있습니다.',
  questionTitle5: '5. 디지털 자산 거래는 어떻게 이루어지나요?',
  questionSubTitle5: '코인왕 거래소에서 거래하려는 디지털 자산을 선택하고 거래 페이지에 진입한 후 구매 또는 판매를 선택하고 거래 수량과 가격을 입력하여 거래를 확인할 수 있습니다. 또한 코인왕 거래소는 비트코인, 이더리움, 라이트코인, 리플 등 다양한 디지털 자산 거래를 지원합니다.',
  questionTitle6: '6. 코인왕 거래소는 어떻게 사용자 자산 안전을 보장하나요?',
  questionSubTitle6: '코인왕 거래소는 다중 계층 암호화 기술을 사용하여 사용자 정보와 자산을 안전하게 보호하며 사용자 자산의 안전을 보장하기 위해 콜드 월렛 및 핫 월렛을 분리하여 저장 방식을 채택합니다.',
  
  orderType: '주문 유형',
  orderStatus: '주문 상태',
  to: '에서',
  startTime: '시작 날짜',
  endTime: '종료 날짜',
  orderNo: '주문 번호',
  status: '상태',
  totalPrice: '총 가격',
  numberOrFee: '거래 수량/수수료',
  tradingPartners: '거래 상대방',
  time: '시간',
  operate: '조작',
  details: '상세정보',
  noPay: '미결제',
  payed: '결제 완료',
  finish: '거래 완료',
  canceled: '취소됨',
  complaint: '불만 제기 중',
  legalCurrency: '법정 통화 금액',
  virtualCurrency: '디지털 화폐',
  virtualCurrencyAddress: '지불 주소',
  paymenttype: '결제 유형',
  creatTime: '생성 시간',
  success: '성공',
  pending: '진행 중',
  awaiting: '확인 대기 중',
  declined: '실패',
  deposittokens:'매도 주문이 사용자의 토큰 입금을 기다리는 중입니다.',
  makepayment:'매수 주문이 사용자의 결제를 기다리는 중입니다.',
  verification:'사용자 신원 확인을 위해 확인 중입니다.',
  Transactioncancelled:'거래가 취소되었습니다.',
  Transactionrejected:'거래가 거부되었습니다.',
  mjskfs: '판매자 수령 방식',
  mjfkfs: '구매자 결제 방식',
  toPay: '지불하러 가기',
  ddzdqx: '{payTime} 내에 결제 방식을 선택하지 않으면 주문이 자동으로 취소됩니다.',
  paying: '상대방이 결제 중...',
  fkckh: '결제 참조 번호:',
  dfwfkqx: '{payTime} 내에 상대방이 결제하지 않으면 주문이 자동으로 취소됩니다.',
  ddqxwfck: '주문이 취소되어 결제 정보를 볼 수 없습니다.',
  ddqxckh: '주문이 취소되어 결제 참조 번호:',
  ssz: '분쟁 중입니다. 대기 중입니다. 결제 참조 번호:',
  qxss: '분쟁 취소',
  xzfkfs: '선택한 결제 방식',
  ddywc: '주문이 완료되었습니다.',
  ss: '분쟁',
  wcfqss: '* 주문이 완료된 후 1분이 지나야 분쟁을 제기할 수 있습니다.',
  bnfqss: '* 완료 후 {time}시간이 지나면 분쟁을 제기할 수 없습니다.',
  zxkf: '* OTC 구매 후 T+1일이 지나야 인출할 수 있습니다. 궁금한 점이 있으면 고객 서비스에 문의하십시오.',
  sjyjn: '판매자가 {deposit} {depositName} 보증금을 지불했습니다.',
  wen1: '1. 언제 지불을 받을 수 있나요?',
  da1: '상대방이 결제를 완료하면 알림을 받게 됩니다.',
  wen2: '2. 구매자가 주문 후 계속 지불하지 않는 경우 어떻게 해야 하나요?',
  da2: '판매자는 주문을 취소할 수 없지만 대기 시간이 길 경우 분쟁을 제기할 수 있으며 고객 서비스 팀이 해결해 드립니다.',
  wen3: '3. 적시에 자산을 방출하지 않으면 어떤 영향이 있나요?',
  da3: '지불을 받은 후에도 지불을 확인하지 않으면 구매자가 분쟁을 제기할 수 있으며 플랫폼에서의 신용에 영향을 줄 수 있습니다. 또한 처리되지 않은 채로 자산이 계속 플랫폼 지갑에 얼어붙을 수 있습니다.',
  wen4: '4. 수금 시 유의사항',
  da4: '1) 상대방의 결제를 실제로 받았는지 여부를 반드시 확인하십시오. 토큰 방출을 재촉하는 이유를 믿지 마십시오. 지불을 확인한 후에 "수령 확인"을 클릭하십시오. 암호화폐 손실을 방지하려면 반드시 확인하십시오!<br/>2) 구매자의 계좌와 플랫폼 계좌의 실명이 일치하지 않을 때 수령 위험을 주의하십시오. 궁금한 점이 있으면 즉시 분쟁을 제기하십시오.',
  qzgdsjnzf: '{payTime} 내에 {associatedAdMerchantNickname}에게 {totalAmounts} {fiatCurrency}을(를) 지불하십시오. 결제 참조 번호:',
  nxdfgm: '{associatedAdMerchantNickname}({realName})님께서 {amount_s} {coinsName}을(를) 구매하셨습니다.',
  dfxngm: '{userNickName}({realName})님께서 {amount_s} {coinsName}을(를) 판매하셨습니다.',
  nxdfcs: '{associatedAdMerchantNickname}({realName})님께서 {amount_s} {coinsName}을(를) 판매하셨습니다.',
  dfxncs: '{userNickName}({realName})님께서 {amount_s} {coinsName}을(를) 구매하셨습니다.',
  dddffx: '상대방이 방출을 기다리는 중...',
  njhdq: '{quantity} {coinsName}을(를) 받게 됩니다.',
  qxdd: '주문 취소',
  kfqss: '지불 후 {complaintPayed}분이 지나도 상대방이 아직도 토큰을 방출하지 않으면 분쟁을 제기할 수 있습니다.',
  yfkfkckh: '상대방이 이미 지불했습니다. 결제 참조 번호:',
  qjkqrsk: '최대한 빨리 수금을 확인하십시오.',
  ddnsk: '수금을 기다리는 중입니다.',
  zfje: '지불 금액',
  skzh: '수금 계정:',
  fkzhxm: '지불 계정 소유자 이름:',
  qdskh: '* 수금 전 반드시 자신의 지불 도구에서 금액을 받았는지 확인하십시오.',
  fbl: '방출 완료',
  dfyqrfk: '* 상대방이 이미 지불을 확인했습니다. {complaintPayed}분 후에도 수금을 받을 수 없는 경우에만 분쟁을 제기할 수 있습니다.',
  jkcssk: '* 상대방이 지불을 확인한 후 24시간이 지나면 우리쪽에서 분쟁을 제기할 수 없으므로 최대한 빨리 수금을 확인하십시오.',
  qrfb: '방출 확인',
  qwbqr: '현재 주문의 금액을 받았으며 금액이 정확한지 확인한 후 방출하십시오.',
  wyqrskzq: '수금이 확인되었으며 금액이 정확합니다.',
  tjssyy: '분쟁 이유를 제출하십시오.',
  srssyy: '분쟁 이유를 입력하십시오.',
  sctpxt: '사진 업로드(선택)',
  upload: '업로드',
  zdscsz: '* 최대 세 장의 사진을 업로드할 수 있으며 jpeg, jpg, png 형식을 지원하며 각 파일은 3Mb 이하여야 합니다.',
  sstj: '제출',
  qrfk: '지불 확인',
  fkje: '지불 금액',
  sdzz: '* 플랫폼은 자동으로 청구를 지원하지 않습니다. 개인 계정에서 위의 계정으로 직접 송금한 후 반드시 지불 버튼을 클릭하십시오. 송금 후 지불 버튼을 클릭하지 않으면 발생하는 손실은 본인이 부담하게 됩니다.',
  bzts: '* 송금 시에는 BTC, USDT, BiKing 등의 정보와 같은 내용을 비고란에 입력하지 마십시오. 그렇지 않으면 판매자가 거부할 수 있습니다.',
  wfk: '지불하지 않음',
  w: '나',
  srxxfs: '정보 입력 후 Enter 키를 누르세요.',
  dan: '단',
  bnch: '동일한 유형의 결제 방식을 추가할 수 없습니다.',
  sd:'스왑',
  from:'지불',
  rate:'환율',
  fees:'요금',
  slippage:'미끄러짐',
  standards:'취급수수료 부과 기준',
  transactionamount:'거래금액의 {num}',
  Exchangetime:'시간',
  records:'스왑기록',
  chaeckrecords:'플래시 사용 기록 전체 보기》',
  tocurrency:'소비통화',
  consumption:'소비량',
  Getcurrency:'통화 받기',
  GetQuantity:'수량 가져오기',
  ExchangeStatus:'상환 상태',
  Youwillconsume:'소비 예정',
  YouwillGET:'당신은 얻을 것이다',
  Updatequote:'견적 업데이트',
  Failed:'사용 실패',
  Consumption:'소비채널',
  Completed:'완전한',
  successful:'상환 성공',
  Converted:'{aaa}를 {bbb}로 성공적으로 변환했습니다',
  recommend:'추천하다',
  wcsj: "완료 시간"
}
const otcMerchant = {
  bzj: '보증금',
  mmggs: '매매 광고 수',
  bx: '무제한',
  ggzed: '광고 총액',
  kzjgged: '추가 가능한 광고액',
  zjbzjbs: '추가 보증금 배수',
  tbzss: '10개 동시 표시',
  tjsjsqb: '상인 신청서를 제출하십시오',
  wcgjkycrz: '고급 KYC 인증 완료',
  ynlx: '양식을 제출한 후 OTC 담당자가 즉시 연락을 드릴 것입니다',

  zbzl: '자료 준비',
  kssh: '빠른 심사',

  h1: '스마트 거래',
  h2: 'C2C 거래 전문가가 되기',
  h3: '인증 상인이 되고 있습니다',
  sjqy: '상인 권익',
  c2cjy: 'C2C 거래 외에도 <span>0 수수료</span>로 상인에게 더 많은 혜택을 제공합니다',
  fbq: '당신의 암호화폐 지역',
  ptsj: '일반 상인',
  xsqy: '인증 상인이 되어 더 많은 혜택을 누리십시오',
  wtd: '신청이 성공하면 주문을 게시할 수 있습니다',
  xjn: '{deposit} 보증금을 내야 합니다',
  ljsq: '지금 신청하세요',
  cwptsj: '당신은 이미 일반 상인입니다',
  cwrzsj: '당신은 이미 인증 상인입니다',
  rzsj: '인증 상인',
  xrd: '거래 시장에서 최고 신뢰도를 누리십시오',
  nbyq: '바이킹 내부 초대 전용',
  rzbs: '더 고귀한 상인 인증 표시',
  pmq: '우선 순위 랭킹 권한을 획득하십시오',
  kffw: '1:1 고객 서비스 제공',
  sjxy: 'OTC{level} 계약',
  xsjc: '초보자 가이드',
  jygz: '거래 규칙',
  close: '닫기',
  submited: '제출 완료',
  submitSuccess: '제출 성공',

  sqsj: '상인 신청',
  fwxy: '바이킹 코인왕 상인 서비스 계약',
  xyb: '코인왕은 사용자들이 디지털 자산 거래를 하고 관련 서비스를 제공하는 전용 플랫폼입니다. 이 계약의 편의를 위해 회사와 이 웹사이트는 이 계약에서 "우리" 또는 다른 일인칭 대명사로 함께 지칭됩니다. 이 웹사이트에 가입하고 로그인한 모든 자연인 또는 다른 주체는 이 웹사이트의 사용자입니다. 이 계약의 편의를 위해 "당신" 또는 다른 이인칭 대명사를 사용합니다. 이 계약의 편의를 위해 우리와 당신은 이 계약에서 "당사"로 함께 지칭되며, 우리 또는 당신이란 각각 "일쪽"으로 지칭됩니다.',
  ptsm: '플랫폼 선언:',
  p1: '1. 본 웹사이트는 디지털 자산 거래 정보를 제공하고 디지털 자산 거래에 대한 협의, 거래 장소를 제공하는 역할을 합니다. 본 웹사이트는 어떠한 실질적인 디지털 자산 거래에도 참여하지 않으므로 거래 당사자는 관련 디지털 자산 및/또는 정보의 진실성, 합법성 및 효력을 스스로 판단하고 이에 대한 책임과 손실을 스스로 부담해야 합니다.',
  p2: '2. 본 웹사이트의 어떠한 의견, 소식, 토론, 분석, 가격, 권고 사항 및 기타 정보는 일반적인 시장 의견일 뿐이며 투자 권고서로 간주되지 않습니다. 우리는 이러한 정보에 의존함으로써 직접 또는 간접적으로 발생하는 어떠한 손실에 대해 어떠한 책임도 지지 않습니다.',
  p3: '3. 본 웹사이트의 콘텐츠는 언제든지 변경될 수 있으며 별도의 통지 없이 변경됩니다. 우리는 웹사이트 정보의 정확성을 보장하기 위해 합당한 조치를 취했지만, 해당 정보의 정확성 정도를 보장할 수 없으며 인터넷 전송이나 통지 및 정보 송수신의 지연 또는 실패로 인한 어떠한 손실에 대해 직접적 또는 간접적인 책임을 지지 않습니다.',
  p4: '4. 인터넷 거래 시스템의 사용은 소프트웨어, 하드웨어 및 인터넷 연결의 실패 등의 위험이 있습니다. 우리는 인터넷의 신뢰성과 가용성을 제어할 수 없으므로 왜곡, 지연 및 연결 실패로 인해 발생하는 손실에 대해 어떠한 책임도 지지 않습니다.',
  p5: '5. 본 웹사이트를 사용하여 세탁, 밀수, 상업 뇌물 등의 모든 불법 거래 활동이나 위법 행위를 금지합니다. 어떠한 불법 거래 활동이나 위법 행위가 발견되면 본 웹사이트는 계정 동결, 관련 권력 기관에 통보 등 다양한 수단을 사용하여 조치를 취할 수 있으며, 이로 인한 손실에 대해 책임지지 않으며 관련 당사자에 대한 책임 추적을 보류합니다.',
  p6: '6. 본 웹사이트를 통해 시장을 조작하거나 부적절한 거래 활동 등 모든 비윤리적 거래 활동을 금지합니다. 이러한 사건이 발생하는 경우 본 웹사이트는 시장 조작, 거래 시스템에 부적절한 영향을 미치는 등의 부적절한 행동에 대해 경고, 거래 제한, 계정 중지 등의 예방 조치를 취할 수 있으며, 이로 인한 손실에 대해 책임지지 않으며 관련 당사자에 대한 책임 추적을 보류합니다.',
  p7: '코인왕 서비스 계약에 동의함으로써 당신은 플랫폼 선언의 모든 내용에 동의한 것으로 간주됩니다. 본 계약은 코인왕과 당사자가 함께 체결한 것으로, 본 계약은 완전한 계약 효력을 갖습니다.',
  zcbzj: '제 1 조 : 자산 보증금',
  p8: '1. 상인이 플랫폼 KYC 및 백색 자산 세탁 검사를 통과하면, 본 플랫폼은 상인에게 해당 플랫폼 계정에 일정한 보증금을 입금하도록 요구할 것입니다. 이는 플랫폼 상에서의 거래 안전과 원활함을 보장하기 위한 것입니다.',
  p9: '2. 보증금의 구체적인 금액은 플랫폼 상의 상인의 법화 자산에 표시되며, 거래 과정에서 사용자에게 표시됩니다.',
  p10: '3. 다음 상황이 발생할 경우, 본 플랫폼은 상인의 보증금을 공제 등의 처분할 권리가 있습니다. 보증금은 ≥1 개월 동안 공제됩니다. 플랫폼과 사용자에게 손해를 입히는 것으로 판단되는 경우, 보증금이 비례적으로 공제됩니다.',
  p11: '1) 거래 과정에서 상인이 분쟁을 일으키고, 상인이 책임을 지고 해당 의무를 이행해야 할 때, 그리고 상인이 협력하지 않는 경우;',
  p12: '2) 상인이 플랫폼 상의 실명되지 않은 계정과 거래하는 경우;',
  p13: '3) 상인이 플랫폼을 통해 어떠한 불법 행위를 하는 경우;',
  p14: '4) 상인이 이 계약이나 본 웹사이트의 다른 법적 문서 또는 거래 규칙을 위반하는 경우;',
  p15: '5) 상인이 사용자를 다른 플랫폼으로 유도하는 경우;',
  p16: '6) 상인이 사용자를 가입 유도하여 플랫폼에서 새 사용자를 유인하는 경우;',
  p17: '7) 상인이 다른 플랫폼으로 사용자를 유도하여 협력 파트너의 사용자를 유도하는 경우.',
  cxzg: '제 2 조 : 상인 자격 취소',
  p18: '다음 상황이 발생할 경우, 본 플랫폼은 당신의 상인 자격을 단독으로 해제할 수 있습니다.',
  p19: '1. 거래 중에 본 플랫폼 사용자의 여러 번의 불만을 받는 경우;',
  p20: '2. 제출된 신청 자료에 어떠한 가짜 정보도 있는 경우;',
  p21: '3. 거래 중에 사기 등의 부정직한 행위가 있는 경우;',
  p22: '4. 본 플랫폼 고객 서비스의 주문 처리에 협력하지 않거나 일부러 지연하는 경우;',
  p23: '5. 이득을 위해 본 플랫폼 규칙을 악용하는 경우;',
  p24: '6. 법률, 이 계약 또는 본 웹사이트의 다른 법적 문서 또는 거래 규칙을 위반하는 경우;',
  p25: '7. 본 플랫폼이 공정한 거래, 사회적 질서, 공정한 거래를 위반하는 것으로 인정하는 경우;',
  p26: '8. 기타 법률 및 규정을 위반하는 행동이 있는 경우.',
  zlbh: '제 3 조 : 상인 정보 보호',
  p27: '1. 상인 정보 관리: 당신이 상인이 되기 위해 본 웹사이트에 제출한 인증 자료(이전에 실명 인증 자료를 포함)는 본 웹사이트에 의해 취소할 수 없는 인증을 부여합니다. 본 웹사이트는 당신의 인증 자료를 공개적으로 편집하거나 공개하지 않을 것으로 약속하며, 본 웹사이트에 저장된 비공개 콘텐츠를 상업적으로 사용하지 않을 것을 약속합니다. 다음은 예외입니다: 당신이 본 웹사이트에 허용한 정보의 공개;',
  p28: '2. 국가 사법 및 행정 기관에 제공;',
  p29: '3. 본 웹사이트가 연계된 회사에 제공;',
  p30: '4. 제3자와 본 웹사이트가 사용자에게 제공하는 서비스에 필요한 관련 정보;',
  p31: '5. 사용자와 제3자 간의 민사 분쟁을 해결하기 위해, 본 웹사이트가 그 정보를 제3자에게 제공하는 권리가 있습니다.',
  sjcn: '제 4 조 : 상인 약속',
  p32: '1. 본 계약의 모든 조항에 동의하는 것이 인증 신청의 전제 조건입니다.',
  p33: '2. 당신은 선량하지 않은 목적으로 또는 이 계약에서 금지된 목적으로 어떠한 인증 신청도 할 수 없습니다.',
  p34: '3. 당신은 플랫폼의 서비스 조건에 위반되지 않도록 상인 신청 서비스를 사용하지 않아야 합니다.',
  p35: '4. 당신은 본 웹사이트의 허가 없이 어떠한 방법으로든 정보 또는 자료를 획득하거나 시도해서는 안됩니다.',
  p36: '5. 당신은 확인하고 약속합니다: 당신의 거래가 본 웹사이트의 규정 또는 순서를 위반하지 않거나 거래 순서를 방해하지 않는 목적으로 이루어진다.',
  p37: '6. 상인은 플랫폼의 디지털 자산 거래를 수행하는 데 필요한 모든 정보 공개 작업 요구 사항을 준수하여 문서, 자료 또는 정보를 제공해야 합니다. 상인이 플랫폼에서 요구하는 문서, 자료 또는 정보를 제공하지 않으면 제3자가 그 결정을 내릴 수 있습니다.',
  ptmz: '제 5 조 : 플랫폼 면책',
  bcfx: '다음과 같은 경우에 본 플랫폼은 어떠한 책임도 부담하지 않습니다:',
  p38: '1. 사용자가 계정 비밀번호를 타인에게 알려주거나 자신의 비밀번호를 잘 보관하지 않거나 계정을 타인과 공유하거나 본 웹사이트의 과실이 아닌 다른 모든 실수로 인해 사용자의 개인 정보가 유출된 경우;',
  p39: '2. 해커 공격, 컴퓨터 바이러스 침투 또는 공격, 전화 통신 기술 조정에 따른 영향, 정부 통제로 인한 일시적인 폐쇄, 본 웹사이트의 잘못이 아닌 제3자로 인한 인증 정보 유출, 분실, 도난 또는 위조 등;',
  p40: '3. 본 웹사이트에 연결된 기타 웹사이트(예: 온라인 은행 등)로 인한 은행 계좌 정보 유출 및 그로 인한 모든 법적 분쟁 및 결과;',
  p41: '4. 사용자가 본 웹사이트에 잘못된, 불완전한, 거짓된 정보를 제공하거나 유지할 경우에 발생하는 문제;',
  p42: '5. 사용자의 자신의 잘못된 행동 또는 무료 의료를 받은 자료 또는 정보에 따른 어떠한 결과;',
  p43: '6. 사용자가 플랫폼 서비스를 사용하여 발생한 손실은 사용자의 잘못된 조작 또는 행동으로 인한 것입니다.',
  bzg: '제 6 조 : 적용 법률과 법원 관할권',
  p44: '1. 본 계약의 해석과 관련하여 법률적 분쟁이 발생한 경우, 중화인민공화국 법률에 따라 해결될 것입니다.',
  p45: '2. 본 계약의 해석 및 적용은 중화인민공화국 법률에 따라 해석됩니다.',
  p46: '3. 본 계약에서 발생하는 분쟁이 발생한 경우, 당사자 간의 협상을 통해 해결할 수 없으면 관련 법률 규정에 따라 소송이 제기될 수 있습니다.',
  p47: '상인 신청이 성공적으로 제출되었습니다. 관련 부서는 신청서를 검토하고 가능한 한 빨리 연락드리겠습니다.',
  "tyxy": "본인은 해당 계약 내용에 동의합니다.",
  "nextStep": "다음 단계"
}
const user = {
  txxz: '자금 비밀번호 변경 후 24시간 출금 불가',
  name: '닉네임',
  rzdj: '신분 인증 등급',
  phone: '휴대폰',
  email: '이메일',
  zzc: '자산 평가',
  hours24: '24시간',
  market: '시장 현황',
  notice: '공지',
  more: '더 보기>>',
  cb: '입금',
  tb: '출금',
  hz: '이체',
  wsm: '미실명',
  cjrz: '초급 인증',
  gjrz: '고급 인증',
  qwgjrz: "고급 인증으로 이동",
  aqszx: '보안 설정 항목 완료',
  xgaqszx: '보안 설정 항목 수정',
  dlmm: '로그인 비밀번호',
  zjdl: '로그인 비밀번호를 설정하면 계정 및 비밀번호로 직접 로그인할 수 있습니다',
  ghmm: '비밀번호 변경',
  sz: '설정',
  jymm: '거래 비밀번호',
  yzjymm: '계정 자금 변동 시 거래 비밀번호를 먼저 확인해야 합니다.',
  ghjymm: '거래 비밀번호 변경',
  sjyz: '휴대폰 인증',
  yzdx: '로그인, 출금, 비밀번호 변경, 보안 설정 시 인증 문자 메시지를 받습니다',
  xgsj: '휴대폰 번호 변경',
  zwbd: '바인딩 안됨',
  ggyz: 'Google 인증',
  syzn: '사용 안내',
  bd: '바인딩',
  yxyz: '이메일 인증',
  tbqr: '자주 사용하는 이메일 주소를 바인딩하여 로그인, 비밀번호 찾기, 출금 확인 시 사용할 수 있습니다',
  bdyx: '이메일 바인딩',
  xgyx: "이메일 수정",
  xyx: "새 이메일",
  dljl: '최근 10 건의 로그인 기록',
  zjdljl: '이것은 최근 10 건의 로그인 기록입니다',
  dlsj: '최근 로그인 시간',
  ip: 'IP 주소',
  aqsz: '보안 설정',
  yhdl: '사용자 로그인',
  xgbdsj: '바인딩 휴대폰 번호 변경',
  bdsj: '휴대폰 번호 바인딩',
  dxyzm: '문자 인증 코드',
  second: '초',
  fsyzm: '인증 코드 전송',
  xsjh: '새 휴대폰 번호',
  ggyzm: 'Google 인증 코드',
  yxyzm: '이메일 인증 코드',
  confirm: '확인',
  edit: '수정',
  srxm: '이름을 입력하세요',
  zjlx: '신분증 유형',
  xzzjlx: '신분증 유형을 선택하세요',
  zjhm: '신분증 번호',
  srzjhm: '신분증 번호를 입력하세요',
  zcsr: '비밀번호를 다시 입력하세요',
  mmbyz: '비밀번호가 일치하지 않습니다!',
  sfz: '주민등록증',
  jgz: '군관증',
  jmtxz: '대만 주민통행증',
  gatxz: '홍콩 및 마카오 주민통행증',
  hwid: '해외 ID',
  srdx: '문자 인증 코드를 입력하세요',
  sryx: '이메일 인증 코드를 입력하세요',
  srgg: 'Google 인증 코드를 입력하세요',
  jdlmm: '기존 로그인 비밀번호',
  xdlmm: '새로운 로그인 비밀번호',
  qrxmm: '새 비밀번호 확인',
  qrdlmm: '로그인 비밀번호 확인',
  jjymm: '기존 거래 비밀번호',
  xjymm: '새 거래 비밀번호',
  qrjymm: '거래 비밀번호 확인',
  qwcyz: '확인을 완료하십시오',
  smrz: '먼저 실명 인증을 진행하십시오',
  sryzm: '인증 코드를 입력하세요',
  srsjh: '전화 번호를 입력하세요',
  xgdlmm: '로그인 비밀번호 수정',
  szdlmm: '로그인 비밀번호 설정',
  xgjymm: '거래 비밀번호 수정',
  szjymm: '거래 비밀번호 설정',
  czmm: '비밀번호 재설정',
  
  bdgg: 'Google 인증기 바인딩',
  lbyzq: 'Google 두 단계 인증기를 다운로드하십시오',
  smewm: 'Google 두 단계 인증기를 사용하여 QR 코드를 스캔하십시오',
  srdm: 'QR 코드를 인식하지 못하는 경우 아래 코드를 수동으로 입력하십시오',
  copy: '복사',
  copySuccess: '복사 성공',
  srzqyx: '올바른 이메일 주소를 입력하세요',
  srsjyzm: '문자 인증 코드를 입력하세요',
  sryxyzm: '이메일 인증 코드를 입력하세요',
  srggyzm: 'Google 인증 코드를 입력하세요',
  passwordTypeError: '비밀번호 형식이 올바르지 않습니다. 비밀번호는 8-32 자리로, 대소문자 및 숫자를 포함해야 합니다.',
  passwordDiff: '비밀번호가 일치하지 않습니다',
  zcsrxmm: '비밀번호를 다시 입력하세요',
  language: '언어',
  bdhb: '로컬 통화',
  wdbph: '스테이블 코인 선호',
  
  相关问题:"관련 질문",
  为什要进行身份认证:"왜 신분 인증을 해야 하나요",
  上传中:"업로드 중...",
  开始上传:"업로드 시작",
  录制第一段视频:"첫 번째 비디오 녹화",
  录制第二段视频:"두 번째 비디오 녹화",
  录制完成:"녹화 완료",
  请手持身份证正面:"신분증 앞면을 손에 들고 얼굴 아래에 놓으세요",
  正对摄像头:"카메라에 맞추어 5초 이상 유지하세요",
  摘下眼镜:"안경, 모자 등 가리개를 제거하세요",
  请按视频文字提示录制视频:"비디오 텍스트 안내에 따라 비디오를 녹화하세요",
  开始录制:"녹화 시작",
  第一段视频:"첫 번째 비디오",
  第二段视频:"두 번째 비디오",
  录制一段视频:"비디오 녹화",
  点击开始录制:"녹화 시작을 클릭하세요",
  视频录像认证:"비디오 녹화 인증",
  身份证号:"신분증 번호",
  证件验证: "신분증 확인 (사진/스캔)",
  zjyz: "신분증 확인",
  请确保图片格式为:"이미지 형식이 jpg/jpeg/png이고 크기가 2MB 이하인지 확인하세요",
  请手持证件照:"신분증 사진과 개인 서명을 손에 들고 Biking + 오늘 날짜가 포함된 서명을 포함해주세요",
  当日签名照:"신분증 사진 + 오늘 날짜 서명",
  上传证件签名页:"신분증 서명 페이지 업로드",
  请保证所有信息清晰:"모든 정보가 명확한지 확인하세요",
  上传证件页信息:"신분증 페이지 정보 업로드",
  请选择国家:"국가를 선택하세요",
  请上传正面证件照:"정면 신분증 사진을 업로드하세요",
  请上传反面证件照:"뒷면 신분증 사진을 업로드하세요",
  手持证件照:"신분증 사진을 손에 들고",
  请选择区域:"지역을 선택하세요",
  认证要求: "인증 요구 사항",
  证件信息: "신분증 정보",
  人脸识别: "얼굴 인식",
  立即认证: "즉시 인증",
  什么是加密货币P2P交易: "암호화폐 P2P 거래란 무엇인가요",
  最好的P2P加密货币交易所是什么: "최고의 P2P 암호화폐 거래소는 무엇입니까?",
  P2P交易的成本有多少: "P2P 거래 비용은 얼마인가요?",
  什么是BikingP2P上的商家: "Biking P2P 상인이란 무엇인가요?",
  我们正在审核您的申请: "귀하의 신청을 검토 중입니다",
  预计审核时间: "예상 검토 시간: 72시간",
  驳回: "거부",
  未提交: "미제출",
  手续费等级: "수수료 등급",
  去认证: "인증하러 가기",
  已认证: "인증 완료",
  开通更多权限: "신분 인증 후 추가 권한을 개방하세요",
  在别人贪婪时要保持警惕:"다른 사람이 탐욕스러울 때 경계를 유지하십시오. 다른 사람이 경계할 때는 욕심내십시오. - 버핏",
  kyc声明: '{Name}입니다. 신분증 번호는 {No}입니다. 저는 Biking에 자발적으로 등록하고 거래하며, 계정이 본인이 사용하고 있음을 보장합니다. 모든 자산이 합법적인 출처에서 비롯되었음을 보장하며 모든 거래 리스크를 이해하고 수용합니다. 추출된 디지털 자산은 불법적인 용도로 사용되지 않으며 본 플랫폼을 통해 세탁, 사기, 불법 환전 등의 불법 활동을 수행하지 않습니다.',
  编辑头像:"프로필 사진 편집",
  请选择一个头像用作您个人资料的照片:"개인 프로필 사진으로 사용할 프로필 사진을 선택하세요",
  中国:"중국",
  其他:"다른" ,
  questionTitle1: '1. 실명 인증을 제공해야 하는 이유는 무엇인가요?',
  questionSubTitle1: 'Biking은 전 세계적으로 규정 준수 인증 서비스를 채택하여 모든 사용자의 자금 안전을 보장합니다. 따라서 정보를 제공할 때 요구 사항을 준수해야 합니다.',
  questionTitle2: '2. 신분 인증 완료의 이점은 무엇인가요?',
  questionSubTitle2: '모든 사용자는 실명 인증을 완료해야만 Biking의 OTC 기능에 액세스할 수 있습니다. 실명 인증을 완료하지 않은 사용자는 온체인 입출금에 영향을 주지 않습니다.',
  questionTitle3: '3. 신분 인증을 어떻게 업데이트 하나요?',
  questionSubTitle3: '신분 정보가 변경되고 다음 조건을 충족하는 경우 온라인 고객 서비스에 문의하여 신분 인증을 업데이트할 수 있습니다',
  questionTitle4: '4. KYC 인증은 얼마나 걸립니까?',
  questionSubTitle4: '제출한 정보는 일반적으로 5분 내에 심사를 받습니다. 그러나 특별한 경우에는 더 많은 시간이 소요될 수 있습니다.',
  questionTitle5: '5. Biking 신분 인증은 안전한가요?',
  questionSubTitle5: 'Biking 신분 인증은 안전합니다. 이는 우리가 여러분과 모든 사용자를 위한 안전한 플랫폼을 구축하는 데 도움이 됩니다. 여러분의 파일은 우리에게 기밀로 처리됩니다.',
  questionTitles:'1. 신분증 만료;',
  questionTitles1:'2. 이름 변경;',
  questionTitles2:'3. 신분증 번호 변경;',
  questionTitles3:'4. 국적 변경;',
  questionTitles4:'5. 법정 사용을 위해 신분증 갱신;',
  questionTitles5:'6. 시스템 언어에 따라 이름 변경 (예 : 국내 신분증에서 여권으로 변경);',
  Z1001: "시스템 오류",
  Z1003: "검증 중단",
  Z2002: "네트워크 오류",
  Z2003: "클라이언트 장치 시간 오류",
  Z2006: "인증 실패",
  Z5050: "얼굴 인증 성공",
  Z5051: "얼굴 이미지 업로드 실패",
  Z5052: "데이터 오류 또는 프로그램 예외.",
  Z5053: "네트워크 오류.",
  Z5054: "카메라 권한 없음 또는 카메라 데이터를 가져올 수 없음.",
  Z5055: "사용자 종료.",
  Z5056: "재시도 횟수 초과.",
  Z5057: "비디오 업로드 시간 초과.",
  Z5058: "비디오 형식이 요구 사항을 충족하지 않음.",
  Z5059: "비디오에서 유효한 얼굴이 없음.",
  Z5128: "인증이 동일한 사람이 아님.",
  法币充值:'법정화폐 입금 및 출금 한도',
  无限额:'무제한',
  数字货币充值:'디지털 화폐 입금',
  数字货币提现限额:'디지털 화폐 출금 한도',
  C2C交易限额:'C2C 거래 한도',
  "参数不合法": '파라미터가 잘못되었습니다',
  h5smrz: "실명인증",
  bhzhan: "귀하의 계정 보안을 보호하기 위해 비밀번호를 설정하세요",
  jxsmrz: "사용자 자금의 보안을 보장하기 위해 실명 인증을 수행합니다",
  qwrz: "인증하기로 이동",
  dgzhzd: "1. 단일 계정은 하루 최대 5회까지 제출할 수 있습니다.",
  rhzp: "2. 귀하가 제출한 모든 사진, 동영상 또는 문서 세부 정보는 저장되거나 어떠한 방식으로도 사용되지 않습니다.",
  sfzm: "신분 증명",
  zjqfg: "증명서 발행 국가",
  dw: "위치",
  sfxx: "신원 정보",
  dqdw: "현재 위치",
  gjdq: "국가/지역"
}

const h5 = {
  "chart": "차트",
  "mmp": "매수/매도 판",
  "sscj": "실시간 체결",
  "wt": "위임",
  "lswt": "과거 위임",
  "zj": "자금",
  "sj": "시가",
  "ky": "사용 가능",
  "zczh": "자산 합계",
  "dj": "동결",
  "zwsj": "데이터 없음",
  "zx": "자유 선택",
  "buysell": "매수/매도"
}

const worldCup = {
  common: {
    cancel: '취소',
    confirm: '확인하다',
    iKnow: '알겠어요',
    points: '완전한',
    day: '하늘',
    hour: '시간',
    minute: '가리키다',
    second: '두번째',
    noData: '데이터 없음',
    noMatch: '경기 없음',
    businessClosed: '서비스가 종료되었습니다',
    loadFailed: '로드 실패, 잠시 후 다시 시도해 주세요',
  },
  index: {
    liveFeed: '실시간 역학',
    heroTitle: '월드컵에 베팅하기',
    heroSplit: '조각하다',
    heroPrizePool: '상금 풀',
    heroMillionPrizePool: '백만 상금 풀 나누기',
    heroSub: 'Tesla 티켓과 월드컵 티켓도 여러분을 기다리고 있습니다.',
    heroJoinedPrefix: '이미',
    heroJoinedSuffix: '사람들이 참여하고 있으며 상금 풀도 계속 늘어나고 있습니다.',
    activityTimeLabel: '활동 시간:',
    refreshing: '상쾌하다...',
    releaseToRefresh: '즉시 새로고침하려면 버튼을 놓으세요.',
    pullToRefresh: '아래로 당겨 새로고침하세요.',
    livePrizePool: '실시간 상금 풀',
    growing: '실시간으로 성장',
    userPoolRatioLabel: '개인 사용자는 상금 풀을 공유할 수 있습니다.',
    teamPoolRatioLabel: '팀은 상금 풀을 공유할 수 있습니다.',
    poolCountdownLabel: '{phase}단계 상금 풀 분배까지 카운트다운',
    poolCountdownFinalLabel: '최종 단계 상금 풀 분배까지 카운트다운',
    poolActivityStartCountdownLabel: '이벤트 시작까지',
    poolSplitDoneBadge: '상금 풀 분배 완료',
    totalAllocatedPoolLabel: '총 분배 상금 풀',
    poolAllocateFirst: '1차 분배',
    poolAllocateSecond: '2차 분배',
    poolAllocateThird: '3차 분배',
    poolAllocateFinal: '최종 분배',
    poolTeamPrefix: '팀: ',
    poolPersonalPrefix: '개인: ',
    poolPersonalCount: '개인: {n}명',
    teamTitle: '팀을 구성하고 수입을 두 배로 늘리세요',
    teamSubPrefix: '팀에 합류하여 발전할 수 있는 기회를 가지세요',
    teamSubSuffix: '소득',
    teamAgentTitle: '에이전트 팀',
    teamAgentDesc: '플랫폼 상담원은 클릭 한 번으로 팀을 구성할 수 있으며, <span class="wc-hl"> 팀원 포인트가 총 팀 포인트 </span>로 합산됩니다. 동시에 팀 작업을 완료하면 <span class="wc-hl"> 추가 팀 포인트 </span>을(를) 얻을 수 있습니다. 팀 포인트가 높을수록 상금 풀 </span>을 공유할 가능성이 <span class="wc-hl"> 커집니다.',
    createTeamNow: '지금 팀을 구성하세요',
    applyAgentNow: '저는 대리인이 아닙니다. 지금 신청하세요.',
    teamUserTitle: '자유 팀',
    teamUserDesc: '에이전트가 될 필요가 없습니다. 무료 팀에 가입하고, 다른 무료 사용자와 팀을 구성하고, <span class="wc-hl2"> 팀 포인트</span>에 참여하고, <span class="wc-hl2"> 상금 공유</span> 기회를 얻을 수 있습니다.',
    joinNow: '지금 가입하세요',
    championTitle: '챔피언십 예측',
    championSub: '각 사용자는 한 번만 예측할 수 있으며 잠긴 후에는 변경할 수 없습니다. 추측이 맞다면 상금 풀을 개별적으로 공유할 수 있습니다.',
    championHintPrefix: '정확한 승자를 예측한 사용자는 상금을 받게 됩니다.',
    championHintSuffix: '조각의 자격',
    championPoolShare: '조각의 자격',
    championWin: '당첨자 추측 축하드립니다',
    championLose: '죄송합니다. 추측이 정확하지 않았습니다.',
    championWinSub: '개인 상금 풀 분배 자격 획득',
    championNoParticipation: '이벤트가 종료되어 예측에 참여하지 않았습니다',
    confirmPredict: '예측 확인',
    predictCountdown: '예측 카운트다운',
    predictEnded: '예측이 종료되었습니다',
    notice1: '사용자 p***12이(가) 방금 베팅을 완료하고 500포인트를 획득했습니다.',
    notice2: '사용자 k***88이 방금 Tesla를 교환했습니다',
    notice3: '사용자 a***23이 방금 베팅을 완료하고 1200 포인트를 획득했습니다.',
    notice4: '사용자 x***56명이 친구를 초대하여 100포인트를 받았습니다.',
    notice5: '사용자 m***07이 방금 월드컵 티켓 1장을 교환했습니다.',
    tabPredict: '도박',
    tabTask: '일',
    tabRank: '순위',
    tabExchange: '교환',
    tabMine: '내 거',
    tabRules: '규칙',
  },
  toast: {
    refreshSuccess: '새로고침 성공',
    predictSuccess: '베팅이 성공했습니다',
    inviteJumping: '초대 페이지로 이동합니다...',
    applyAgentPending: '에이전트 신청 기능은 개발중이니 많은 관심 부탁드립니다!',
    championLocked: '우승 예측이 잠겨있습니다!',
    exchangeSubmitted: '교환 신청서가 성공적으로 제출되었으며 플랫폼 고객 서비스에서 상품 배포를 위해 연락을 드릴 것입니다.',
    pointsNotEnough: '포인트가 부족합니다',
    createTeamSubmitted: '팀 생성에 성공했습니다.',
    joinedFreeTeam: '프리덤팀에 합류했습니다',
  },
  section: {
    predictTitle: '경기 베팅',
    predictSub: '게임 결과를 예측하세요. 정답일 경우 +{correctPoints}점, 오답일 경우 +{wrongPoints}점',
    predictRules: '베팅 지침',
    taskTitle: '작업을 완료하여 포인트를 획득하세요',
    taskSub: '다양한 작업, 다양한 보상, 수익 축적 가속화',
    exchangeTitle: '포인트환매몰',
    exchangeSub: '푸짐한 경품, 선착순',
    exchangeRules: '상환 지침',
    rankTitle: '실시간 리더보드',
    rankSub: '힘차게 경쟁하여 최고의 자리에 오르세요',
    rulesTitle: '활동 규칙',
    rulesSub: '투명하고 개방적이며 공정하고 정의로운',
  },
  dialog: {
    taskTitle: '사명 선언문',
    taskReward: '완료 시 이용 가능',
    predictConfirmTitle: '경기 베팅',
    predictConfirmHint: '어느 팀이 이길 것 같나요?',
    predictPay: '지불하다',
    predictPayTip: '자금 계좌에서 차감하세요. 잔액이 충분한지 확인하세요.',
    predictConfirmBtn: '베팅 확인',
    predictSuccessTitle: '내기는 성공했다',
    predictSuccessDesc: '베팅 결과가 성공적으로 제출되었으며, 해당 기록은 "내 베팅"에서 확인할 수 있습니다.',
    exchangeTitle: '제품교환',
    exchangeNeedPoints: '필요 포인트',
    exchangeBalance: '균형:',
    exchangeContactTitle: '연락처 정보를 하나 이상 입력하세요.',
    exchangeTipTitle: '친절한 팁',
    exchangeTip1: '연락처 정보를 하나 이상 입력해 주세요. 제출 후 플랫폼 고객 서비스에서 귀하에게 연락하여 상품 배포에 대해 안내할 것입니다.',
    exchangeTip2: '오랫동안 연락이 없으실 경우 고객센터로 연락주시면 처리해드리겠습니다.',
    exchangeConfirm: '교환 확인',
    teamJoinTitle: '팀에 합류하세요',
    teamCreateDesc: '팀을 구성하시겠습니까?',
    teamJoinFreeDesc: 'Freedom Team에 합류하시겠습니까?',
    teamJoinTipTitle: '친절한 팁',
    teamJoinTipDesc: '귀하는 상담원 팀 구성원이므로 무료 팀에 가입할 수 없습니다. 초대자(에이전트)를 초대하여 팀을 구성하여 팀 전투에 참여할 수 있습니다.',
    applyAgentContactTitle: '중요 안내',
    applyAgentContactPrefix: 'Telegram을 추가해 주세요: ',
    applyAgentContactSuffix: ' 에이전트 신청을 진행해 주세요. 에이전트 승인 후 팀을 생성할 수 있습니다.',
    applyAgentContactBtn: '확인',
  },
  rank: {
    teamRank: '팀 순위',
    personRank: '개인 순위',
    yourTeamRank: '당신의 팀 순위',
    yourPersonRank: '당신의 개인 순위',
    captain: '팀 리더:',
    currentPoints: '현재 포인트',
    members: '회원',
    teamDetail: '팀 상세',
    noRankYet: '순위가 없습니다',
  },
  mine: {
    myPoints: '내 포인트',
    totalPoints: '총점',
    myPredict: '내 내기',
    myExchange: '나의 거래소',
    myBonus: '나의 보너스',
    totalBonus: '내가 받은 총 보너스',
    bonusPhase: '분배 단계：',
    bonusPhaseFirst: '1단계',
    bonusPhaseSecond: '2단계',
    bonusPhaseThird: '3단계',
    bonusPhaseFinal: '최종 단계',
    bonusTypeTeam: '팀 풀',
    bonusTypePersonal: '개인 풀',
    bonusPoints: '분배 시 포인트：',
    bonusType: '유형：',
    bonusAmount: '보너스：',
    totalCount: '총 {total}건',
    myTeam: '내 팀',
    selectTeam: '팀을 선택하세요',
    predictMatch: '경기',
    winTeam: '승리한 팀',
    predictResult: '베팅 결과',
    hit: '정확하게 추측했습니다',
    miss: '추측되지 않음',
    draw: '무승부',
    exchangeItem: '아이템 교환',
    contactInfo: '연락처 정보',
    exchangeStatus: '상환 상태',
    currentRank: '현재 순위',
    notJoinedTeam: '팀에 가입하지 않았습니다',
    memberContribution: '회원 기여',
    teamTaskContribution: '팀 과제 기여',
    loading: '로드 중...',
    statusDone: '완전한',
    statusPending: '처리',
    statusFail: '사용 실패',
    logCompleteKyc: 'KYC 완료',
    logExchangePrize: '경품 상환',
    logMatchPredict: '경기 베팅',
    logDailySign: '매일 체크인',
    logFinishTask: '작업을 완료하세요',
    taskFirstRecharge: '첫 번째 입금 완료 >= {amount} USDT',
    pagerTotal: '총 {total} 항목',
    prevPage: '이전 페이지',
    nextPage: '다음 페이지',
    goTo: '이동',
    page: '페이지',
  },
  mobile: {
    title: '월드컵 베팅',
  },
  nav: {
    entry: '월드컵 베팅',
  },
  mock: {
    korea: '대한민국',
    germany: '독일',
    china: '중국',
    uk: '영국',
    france: '프랑스',
    portugal: '포르투갈',
    senegal: '세네갈',
    brazil: '브라질',
    india: '인도',
    turkiye: '터키어',
    usa: '미국',
    jerseyPack: '공식 저지 세트',
    vipCard: 'VIP 암호화 회원 카드',
    jerseyKeyword: '저지',
  },
  predict: {
    round: {
      group: '그룹 스테이지',
      r32: '32강',
      r16: '16강',
      quarter: '준준결승',
      semi: '준결승',
      third: '3위전',
      final: '결승',
    },
    status: {
      joined: '이미 참여했습니다',
      open: '열려 있는',
      ongoing: '게임 도중',
      ended: '끝났다',
    },
    btn: {
      joined: '이미 걸었어',
      open: '{betPaymentAmount}USDT 지금 베팅하세요',
      ongoing: '게임이 진행 중입니다.',
      ended: '베팅이 종료되었습니다',
    },
    joinedMatchPhase: {
      pending: '미시작',
      ongoing: '진행 중',
      ended: '종료',
    },
    joinedResult: {
      hit: '적중 +{points}',
      missPrefix: '미적중',
      missSuffix: '+{points}',
    },
  },
  rules: {
    fundSource: '자금 출처',
    poolSplit: '상금 공유',
    teamIntro: '팀 설명',
    poolRulesTitle: '상금 풀 설명',
    teamRulesTitle: '팀 설명',
    predictRulesTitle: '베팅 지침',
    exchangeRulesTitle: '상환 지침',
  },
  rulesText: {
    poolDesc1: '이벤트의 초기 보너스는 {initialFunds} USDT입니다. 이벤트 유효 기간 동안 총 상금 규모가 지속적으로 증가함에 따라 비즈니스 보너스의 일부가 상금 풀에 투자됩니다.',
    poolLine1: '각 충전 금액의 {rechargePercentageToPool}%이(가) 자동으로 상금 풀에 들어갑니다.',
    poolLine2: '각 무기한(선물) 계약 거래 수수료 중 {contractFeePercentageToPool}%이 자동으로 상금 풀에 입력됩니다.',
    poolLine3: '유효한 사용자가 초대될 때마다 상금 풀은 자동으로 {additionalAmountPerValidUser} USDT씩 증가합니다.',
    poolLine4: '*0.01 USDT 미만은 상금 풀에 반영되지 않습니다.',
    teamPoolTitle: '팀 공유 상금 풀 규칙',
    teamPoolRuleTitle: '팀 공유 상금 풀 규칙',
    teamPoolRule1: '팀이 상금을 얻으면 팀장(자유팀 제외)은 20%의 상금을 받습니다. 팀장 보너스 = 총 상금 풀 * 해당 분배 비율 * 20%',
    teamPoolRule2: '팀원이 상금을 공유하기 위한 자격 요건을 충족한 팀원은 개인 점수 기여도 가중치에 따라 상금을 분배합니다. 팀원 상금 = [(총 상금 풀 * 해당 팀 분배 비율) * (1 - 0.2) / 자격 요건을 충족한 팀원 개인 점수 합계] * 개인 총 점수',
    userPoolTitle: '개인 사용자가 상금을 공유하는 규칙',
    poolSplit1: '첫 번째: 상위 8개 팀이 결정된 후 포인트 1위 팀이 상금의 {percentage}%를 공유하게 되며, 잔액은 계속 누적됩니다.',
    poolSplit2: '두 번째: 상위 4개 팀이 결정된 후 포인트 1위 팀이 상금의 {percentage}%를 공유하게 되며, 잔액은 계속 누적됩니다.',
    poolSplit3: '세 번째: 준결승 이후 포인트 1위 팀은 상금의 {percentage}%를 공유하게 되며, 잔액은 계속 누적됩니다.',
    poolSplit4: '최종: 결승전 후 포인트 1위 팀이 전체 상금의 {percentage}%를 공유하게 됩니다. 분배 종료 후 팀원들의 사용 가능 포인트는 0으로 초기화됩니다.',
    userPoolLine1: '게임이 끝나면 우승을 정확하게 추측한 사용자가 개별적으로 상금을 공유할 수 있습니다.',
    userPoolLine2: '승자를 추측하는 모든 사용자는 총 개인 포인트를 기준으로 상금 풀의 {percentage}%를 공유하게 됩니다. 분배 종료 후 개인 사용 가능 포인트는 0으로 초기화됩니다.',
    poolFormula: '*예: 특정 팀에서 분배 자격이 있는 사용자가 N명이고, 각 사용자 점수를 N1, N2, N3...Nn, 분배 시 총 상금 풀을 A, 해당 회차 분배 비율을 20%, 팀장 보상 비율을 20%로 하면, 팀원 보상 = [(A*20%)(1-0.2)/(N1+N2+N3+...+Nn)]*개인 총점',
    teamRule1: '1. 1급 에이전트만이 팀 구성을 시작할 수 있습니다. 에이전트가 아닌 경우 에이전트로 신청하여 팀을 구성할 수 있습니다.',
    teamRule2: '2. 에이전트가 아니거나 에이전트 자격을 취득할 수 없는 경우 플랫폼에서 설정한 무료 팀(에이전트가 아닌 사용자)에 가입할 수 있습니다.',
    teamRule3: '3. 에이전트가 팀을 구성하면 에이전트와 그의 팀원은 자동으로 팀이 됩니다.',
    teamRule4: '4.총 팀 포인트 = 총 팀원 포인트 + 팀 과제 보상 포인트',
    teamRule5: '5. 팀원이 상금을 공유하기 위한 자격 요건: 이벤트 기간 동안 추측에 ≥ {quizTimesThreshold}회 참여 + 무기한(선물) 계약 거래량 ≥ {poolContractThreshold}U',
    predictRule1: '1. 경기 시작 후 베팅이 종료됩니다.',
    predictRule2: '2. 각 사용자는 게임당 한 번만 추측에 참여할 수 있습니다.',
    predictRule3: '3. 베팅하려면 {betPaymentAmount} USDT를 지불해야 합니다.',
    predictRule4: '4. 승리팀을 맞히면 +{correctBonusPoints}점, 틀리면 +{wrongBonusPoints}점',
    predictRule5: '5. 경기(조별 예선)가 "동점"일 경우, 오답으로 점수가 계산되며, +{wrongBonusPoints}점',
    exchangeRule1: '1. 상품 수는 제한되어 있으며 재고가 소진될 때까지 교환됩니다. 선착순.',
    exchangeRule2: '2. 상품 교환 후 해당 포인트가 차감되며, 그에 따라 팀의 포인트도 차감됩니다.',
    exchangeRule3: '3. 경품 교환 시 연락처를 입력해 주세요. 이후 경품 지급 관련 사항은 플랫폼 직원이 연락드립니다.',
    exchangeRule4: '4. 교환 시 기재한 연락처가 정확하지 않을 경우 경품 교환이 차단될 수 있습니다. 꼼꼼히 확인하고 확인하시고, 계속해서 소식에 관심 가져주시길 바랍니다.',
    exchangeRule5: '5. 오랫동안 플랫폼으로부터 연락을 받지 못한 경우, 플랫폼 고객센터로 문의하여 처리해 주시기 바랍니다.',
    timeTitle: '활동 시간',
    activePeriodLabel: '활동 유효 시간:',
    activePeriodValue: '{startTime} ~ {endTime}',
    activeTip: '포인트는 이벤트가 시작된 후에만 계산되고 집계되며 상금 풀이 쌓이기 시작합니다.',
    predictPeriodLabel: '베팅 시간:',
    predictPeriodValue: '챔피언베팅 : {startTime} ~ {endTime}',
    businessTitle: '비즈니스 규칙',
    businessRule1: '1. 유효한 초대 사용자: 유효한 초대는 초대 대상자의 재충전이 ≥{inviteRechargeThreshold}U이고 무기한(선물) 계약 거래량이 ≥{contractVolumeThreshold}U임을 의미합니다.',
    businessRule2: '2. 팀원이 상금을 공유하기 위한 자격 요건: 이벤트 기간 동안 추측에 ≥ {quizTimesThreshold}회 참여 + 무기한(선물) 계약 거래량 ≥ {poolContractThreshold}U',
    businessRule3: '3. 개인 포인트는 언제든지 선물로 교환될 수 있습니다. 상환 후 해당 개인 및 팀 포인트가 차감됩니다.',
    businessRule4: '4. 실제 경품의 수는 제한되어 있으므로 재고가 소진될 때까지 교환해야 합니다.',
    businessRule5: '5. 월드컵 티켓 교환 마감일은 월드컵 개막 하루 전입니다. 불가항력으로 인해 실물 티켓을 교환할 수 없는 경우, 상응하는 USDT로 교환할 수 있습니다.',
    statementTitle: '엄숙한 성명',
    statement1: '1. 각 사용자는 하나의 계정만 사용하여 활동에 참여할 수 있습니다. 활동에 참여하기 위해 여러 계정(일괄 등록 계정, 관련 계정 등을 포함하되 이에 국한되지 않음)을 사용하는 것은 엄격히 금지됩니다. 시스템은 참여 계정의 로그인 장치와 IP 주소를 모니터링합니다. 동일한 장치 또는 동일한 IP 주소를 사용하여 여러 계정이 운영되고 있는 것으로 확인되는 경우 플랫폼은 이를 관련 계정으로 결정할 권리가 있습니다.',
    statement2: '2. 활동에 참여하는 사용자의 거래 행위는 진실되고 유효해야 하며, 모든 형태의 역거래, 역거래 또는 자기 거래는 엄격히 금지됩니다.',
    statement3: '3. 플랫폼은 위험 통제 시스템을 통해 고주파 역개방 및 청산, 동일한 가격의 거래 헤징, 저위험 차익 거래 행위 등을 포함하되 이에 국한되지 않는 비정상적인 거래 행위를 식별합니다.',
    statement4: '4. 비정상적인 거래 행위가 발견되면 플랫폼은 다음과 같은 권리를 가집니다. 거래의 이 부분에서 생성된 포인트를 삭제하고, 활동에 참여할 수 있는 사용자 자격을 취소하고, 관련 보상을 동결 또는 철회할 수 있습니다.',
    statement5: '5. 상금 규모와 보상 분배는 플랫폼의 최종 통계 결과에 따릅니다. 플랫폼은 본 이벤트의 규칙에 대한 최종 해석권을 보유합니다.',
  },
  exchange: {
    needPoints: '필요 포인트',
    stock: '남은 재고',
    buyNow: '지금 사용하세요',
    soldOut: '매진',
    badgeUnique: '사이트 내 유일한 대상',
    badgeOnlyCount: '단 {count}개',
    itemFinalTicket: '월드컵 결승전 티켓',
    itemSignedFootball: '사인 축구',
  },
  task: {
    earnPoints: '포인트 적립',
    goFinish: '완료하다',
    goTeamTask: '작업으로 팀 포인트 적립',
  },
  taskGroup: {
    daily: '일일 업무',
    invite: '작업 초대',
    recharge: '업무 재충전',
    teamTrade: '팀 트레이딩 작업',
    dailyLimitPrefix: '일일 보상 한도',
    teamLimitPrefix: '팀 일일 보상 한도',
    limitPoints: '{num}점',
    limitSuffix: ', 매일 00:00:00(GMT+08:00)에 새로고침됩니다.',
    rechargeLimitSuffix: '이벤트 기간 중 최초 충전 1회만 계산하여 기준 충족 여부를 확인합니다.',
    inviteCta: '지금 초대하고 포인트를 획득하세요',
    taskPredictOnce: '이벤트 베팅에 참여할 때마다',
    taskTrade10000: '각 누적 완료된 무기한(선물) 계약 거래량은 {tradeVolume}U입니다.',
    taskInviteValidUser: '유효한 사용자 초대가 완료될 때마다',
    taskInviteRegister: '친구를 초대하여 등록하세요',
    taskInviteKyc: 'KYC를 완료하도록 친구를 초대하세요',
    taskInviteRecharge: '첫 번째 충전을 완료하도록 친구를 초대하세요',
    taskFirstRecharge: '첫 번째 충전 >= {amount} USDT',
    taskTeamTrade10000: '누적 {tradeVolume} USDT 무기한(선물) 계약 거래가 완료될 때마다 팀은 +{teamBonusPoints} 포인트를 받게 됩니다.',
  },
};
export {
  apis,
  games,
  h5,
  trading,
  download,
  login,
  user,
  advertise,
  otcMerchant,
  otc,
  menu,
  time,
  state,
  text,
  seckillRes,
  header,
  hyy,
  index,
  indexPage,
  Verification,
  NAVS,
  FOOTERS,
  SIDEBAR,
  seckill,
  apply,
  recommend,
  market,
  banner,
  card,
  news,
  info,
  navCard,
  choice,
  plat,
  risk,
  license,
  footer,
  merchandiser,
  codeInfo,
  placeOrder,
  tableList,
  codelist,
  contractHyy,
  common,
  dialog,
  panKou,
  invite,
  property,
  contest,
  taskCenter,
  ieo,
  earn,
  tradingContest,
  agent,
  live,
  hongbao,
  worldCup
};



// WEBPACK FOOTER //
// ./src/i18n/lang/public/kr.js